(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire1442"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire1442"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("ewJru", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9374dc55a96e46b$export$2e2bcd8739ae039);
const baseUrl = document.currentScript?.getAttribute("data-base") ?? "/";
const searchJsonUrl = baseUrl + "search.json";
const pagefindUrl = baseUrl + "pagefind/pagefind.js";
function $a9374dc55a96e46b$export$2e2bcd8739ae039(Alpine) {
    Alpine.data("search", ()=>({
            _notes$: null,
            _pagefind: null,
            open: false,
            term: "",
            results: null,
            selectedId: null,
            init () {
                this.$watch("term", async ()=>{
                    const results = await this.search();
                    if (results) {
                        this.results = results;
                        this.open = true;
                        this.selectedId = this.results[0]?.id ?? null;
                    }
                });
            },
            get selectedIdx () {
                return this.results.findIndex((r)=>r.id === this.selectedId);
            },
            selectPrevResult () {
                const newIdx = Math.max(0, this.selectedIdx - 1);
                this.selectedId = this.results[newIdx].id;
            },
            selectNextResult () {
                const newIdx = Math.min(this.results.length - 1, this.selectedIdx + 1);
                this.selectedId = this.results[newIdx].id;
            },
            onKeyDown (event) {
                switch(event.key){
                    case "Escape":
                        this.open = false;
                        break;
                    case "ArrowUp":
                        event.preventDefault();
                        this.results && this.selectPrevResult();
                        break;
                    case "ArrowDown":
                        event.preventDefault();
                        this.results && this.selectNextResult();
                        break;
                    case "Enter":
                        event.preventDefault();
                        const result = this.results?.[this.selectedIdx];
                        if (result) window.location.href = result.url;
                        break;
                }
            },
            async fetchNotes () {
                if (!this._notes) this._notes = new Promise(async (resolve)=>{
                    const result = await fetch(searchJsonUrl).then((r)=>r.json());
                    resolve(result.notes);
                });
                return this._notes;
            },
            async loadPagefind () {
                if (!this._pagefind) this._pagefind = new Promise(async (resolve)=>{
                    // Workaround, waiting for https://github.com/parcel-bundler/parcel/issues/8316
                    const pagefind = await eval(`import("${pagefindUrl}")`);
                    await pagefind.options({
                        excerptLength: 15
                    });
                    resolve(pagefind);
                });
                return this._pagefind;
            },
            async search () {
                const pagefind = await this.loadPagefind();
                const tagsQuery = this.term.match(/#(\S+)/g) ?? [];
                const tags = tagsQuery.map((tag)=>tag.substring(1));
                const termWithoutTags = this.term.replace(/#(\S+)/g, "").trim();
                const searchTerm = termWithoutTags || null;
                const filters = tags.length ? {
                    tags: tags
                } : undefined;
                const search = await pagefind.debouncedSearch(searchTerm, {
                    filters: filters
                });
                if (!search) return null;
                const results = await Promise.all(search.results.map((x)=>x.data()));
                return results.map((x)=>({
                        id: x.url,
                        url: x.url,
                        title: x.meta.title,
                        excerpt: x.excerpt
                    }));
            }
        }));
}

});

// packages/alpinejs/src/scheduler.js
var $f347e48613385d9c$var$flushPending = false;
var $f347e48613385d9c$var$flushing = false;
var $f347e48613385d9c$var$queue = [];
var $f347e48613385d9c$var$lastFlushedIndex = -1;
function $f347e48613385d9c$var$scheduler(callback) {
    $f347e48613385d9c$var$queueJob(callback);
}
function $f347e48613385d9c$var$queueJob(job) {
    if (!$f347e48613385d9c$var$queue.includes(job)) $f347e48613385d9c$var$queue.push(job);
    $f347e48613385d9c$var$queueFlush();
}
function $f347e48613385d9c$var$dequeueJob(job) {
    let index = $f347e48613385d9c$var$queue.indexOf(job);
    if (index !== -1 && index > $f347e48613385d9c$var$lastFlushedIndex) $f347e48613385d9c$var$queue.splice(index, 1);
}
function $f347e48613385d9c$var$queueFlush() {
    if (!$f347e48613385d9c$var$flushing && !$f347e48613385d9c$var$flushPending) {
        $f347e48613385d9c$var$flushPending = true;
        queueMicrotask($f347e48613385d9c$var$flushJobs);
    }
}
function $f347e48613385d9c$var$flushJobs() {
    $f347e48613385d9c$var$flushPending = false;
    $f347e48613385d9c$var$flushing = true;
    for(let i = 0; i < $f347e48613385d9c$var$queue.length; i++){
        $f347e48613385d9c$var$queue[i]();
        $f347e48613385d9c$var$lastFlushedIndex = i;
    }
    $f347e48613385d9c$var$queue.length = 0;
    $f347e48613385d9c$var$lastFlushedIndex = -1;
    $f347e48613385d9c$var$flushing = false;
}
// packages/alpinejs/src/reactivity.js
var $f347e48613385d9c$var$reactive;
var $f347e48613385d9c$var$effect;
var $f347e48613385d9c$var$release;
var $f347e48613385d9c$var$raw;
var $f347e48613385d9c$var$shouldSchedule = true;
function $f347e48613385d9c$var$disableEffectScheduling(callback) {
    $f347e48613385d9c$var$shouldSchedule = false;
    callback();
    $f347e48613385d9c$var$shouldSchedule = true;
}
function $f347e48613385d9c$var$setReactivityEngine(engine) {
    $f347e48613385d9c$var$reactive = engine.reactive;
    $f347e48613385d9c$var$release = engine.release;
    $f347e48613385d9c$var$effect = (callback)=>engine.effect(callback, {
            scheduler: (task)=>{
                if ($f347e48613385d9c$var$shouldSchedule) $f347e48613385d9c$var$scheduler(task);
                else task();
            }
        });
    $f347e48613385d9c$var$raw = engine.raw;
}
function $f347e48613385d9c$var$overrideEffect(override) {
    $f347e48613385d9c$var$effect = override;
}
function $f347e48613385d9c$var$elementBoundEffect(el) {
    let cleanup2 = ()=>{};
    let wrappedEffect = (callback)=>{
        let effectReference = $f347e48613385d9c$var$effect(callback);
        if (!el._x_effects) {
            el._x_effects = /* @__PURE__ */ new Set();
            el._x_runEffects = ()=>{
                el._x_effects.forEach((i)=>i());
            };
        }
        el._x_effects.add(effectReference);
        cleanup2 = ()=>{
            if (effectReference === void 0) return;
            el._x_effects.delete(effectReference);
            $f347e48613385d9c$var$release(effectReference);
        };
        return effectReference;
    };
    return [
        wrappedEffect,
        ()=>{
            cleanup2();
        }
    ];
}
function $f347e48613385d9c$var$watch(getter, callback) {
    let firstTime = true;
    let oldValue;
    let effectReference = $f347e48613385d9c$var$effect(()=>{
        let value = getter();
        JSON.stringify(value);
        if (!firstTime) queueMicrotask(()=>{
            callback(value, oldValue);
            oldValue = value;
        });
        else oldValue = value;
        firstTime = false;
    });
    return ()=>$f347e48613385d9c$var$release(effectReference);
}
// packages/alpinejs/src/mutation.js
var $f347e48613385d9c$var$onAttributeAddeds = [];
var $f347e48613385d9c$var$onElRemoveds = [];
var $f347e48613385d9c$var$onElAddeds = [];
function $f347e48613385d9c$var$onElAdded(callback) {
    $f347e48613385d9c$var$onElAddeds.push(callback);
}
function $f347e48613385d9c$var$onElRemoved(el, callback) {
    if (typeof callback === "function") {
        if (!el._x_cleanups) el._x_cleanups = [];
        el._x_cleanups.push(callback);
    } else {
        callback = el;
        $f347e48613385d9c$var$onElRemoveds.push(callback);
    }
}
function $f347e48613385d9c$var$onAttributesAdded(callback) {
    $f347e48613385d9c$var$onAttributeAddeds.push(callback);
}
function $f347e48613385d9c$var$onAttributeRemoved(el, name, callback) {
    if (!el._x_attributeCleanups) el._x_attributeCleanups = {};
    if (!el._x_attributeCleanups[name]) el._x_attributeCleanups[name] = [];
    el._x_attributeCleanups[name].push(callback);
}
function $f347e48613385d9c$var$cleanupAttributes(el, names) {
    if (!el._x_attributeCleanups) return;
    Object.entries(el._x_attributeCleanups).forEach(([name, value])=>{
        if (names === void 0 || names.includes(name)) {
            value.forEach((i)=>i());
            delete el._x_attributeCleanups[name];
        }
    });
}
function $f347e48613385d9c$var$cleanupElement(el) {
    el._x_effects?.forEach($f347e48613385d9c$var$dequeueJob);
    while(el._x_cleanups?.length)el._x_cleanups.pop()();
}
var $f347e48613385d9c$var$observer = new MutationObserver($f347e48613385d9c$var$onMutate);
var $f347e48613385d9c$var$currentlyObserving = false;
function $f347e48613385d9c$var$startObservingMutations() {
    $f347e48613385d9c$var$observer.observe(document, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeOldValue: true
    });
    $f347e48613385d9c$var$currentlyObserving = true;
}
function $f347e48613385d9c$var$stopObservingMutations() {
    $f347e48613385d9c$var$flushObserver();
    $f347e48613385d9c$var$observer.disconnect();
    $f347e48613385d9c$var$currentlyObserving = false;
}
var $f347e48613385d9c$var$queuedMutations = [];
function $f347e48613385d9c$var$flushObserver() {
    let records = $f347e48613385d9c$var$observer.takeRecords();
    $f347e48613385d9c$var$queuedMutations.push(()=>records.length > 0 && $f347e48613385d9c$var$onMutate(records));
    let queueLengthWhenTriggered = $f347e48613385d9c$var$queuedMutations.length;
    queueMicrotask(()=>{
        if ($f347e48613385d9c$var$queuedMutations.length === queueLengthWhenTriggered) while($f347e48613385d9c$var$queuedMutations.length > 0)$f347e48613385d9c$var$queuedMutations.shift()();
    });
}
function $f347e48613385d9c$var$mutateDom(callback) {
    if (!$f347e48613385d9c$var$currentlyObserving) return callback();
    $f347e48613385d9c$var$stopObservingMutations();
    let result = callback();
    $f347e48613385d9c$var$startObservingMutations();
    return result;
}
var $f347e48613385d9c$var$isCollecting = false;
var $f347e48613385d9c$var$deferredMutations = [];
function $f347e48613385d9c$var$deferMutations() {
    $f347e48613385d9c$var$isCollecting = true;
}
function $f347e48613385d9c$var$flushAndStopDeferringMutations() {
    $f347e48613385d9c$var$isCollecting = false;
    $f347e48613385d9c$var$onMutate($f347e48613385d9c$var$deferredMutations);
    $f347e48613385d9c$var$deferredMutations = [];
}
function $f347e48613385d9c$var$onMutate(mutations) {
    if ($f347e48613385d9c$var$isCollecting) {
        $f347e48613385d9c$var$deferredMutations = $f347e48613385d9c$var$deferredMutations.concat(mutations);
        return;
    }
    let addedNodes = [];
    let removedNodes = /* @__PURE__ */ new Set();
    let addedAttributes = /* @__PURE__ */ new Map();
    let removedAttributes = /* @__PURE__ */ new Map();
    for(let i = 0; i < mutations.length; i++){
        if (mutations[i].target._x_ignoreMutationObserver) continue;
        if (mutations[i].type === "childList") {
            mutations[i].removedNodes.forEach((node)=>{
                if (node.nodeType !== 1) return;
                if (!node._x_marker) return;
                removedNodes.add(node);
            });
            mutations[i].addedNodes.forEach((node)=>{
                if (node.nodeType !== 1) return;
                if (removedNodes.has(node)) {
                    removedNodes.delete(node);
                    return;
                }
                if (node._x_marker) return;
                addedNodes.push(node);
            });
        }
        if (mutations[i].type === "attributes") {
            let el = mutations[i].target;
            let name = mutations[i].attributeName;
            let oldValue = mutations[i].oldValue;
            let add2 = ()=>{
                if (!addedAttributes.has(el)) addedAttributes.set(el, []);
                addedAttributes.get(el).push({
                    name: name,
                    value: el.getAttribute(name)
                });
            };
            let remove = ()=>{
                if (!removedAttributes.has(el)) removedAttributes.set(el, []);
                removedAttributes.get(el).push(name);
            };
            if (el.hasAttribute(name) && oldValue === null) add2();
            else if (el.hasAttribute(name)) {
                remove();
                add2();
            } else remove();
        }
    }
    removedAttributes.forEach((attrs, el)=>{
        $f347e48613385d9c$var$cleanupAttributes(el, attrs);
    });
    addedAttributes.forEach((attrs, el)=>{
        $f347e48613385d9c$var$onAttributeAddeds.forEach((i)=>i(el, attrs));
    });
    for (let node of removedNodes){
        if (addedNodes.some((i)=>i.contains(node))) continue;
        $f347e48613385d9c$var$onElRemoveds.forEach((i)=>i(node));
    }
    for (let node of addedNodes){
        if (!node.isConnected) continue;
        $f347e48613385d9c$var$onElAddeds.forEach((i)=>i(node));
    }
    addedNodes = null;
    removedNodes = null;
    addedAttributes = null;
    removedAttributes = null;
}
// packages/alpinejs/src/scope.js
function $f347e48613385d9c$var$scope(node) {
    return $f347e48613385d9c$var$mergeProxies($f347e48613385d9c$var$closestDataStack(node));
}
function $f347e48613385d9c$var$addScopeToNode(node, data2, referenceNode) {
    node._x_dataStack = [
        data2,
        ...$f347e48613385d9c$var$closestDataStack(referenceNode || node)
    ];
    return ()=>{
        node._x_dataStack = node._x_dataStack.filter((i)=>i !== data2);
    };
}
function $f347e48613385d9c$var$closestDataStack(node) {
    if (node._x_dataStack) return node._x_dataStack;
    if (typeof ShadowRoot === "function" && node instanceof ShadowRoot) return $f347e48613385d9c$var$closestDataStack(node.host);
    if (!node.parentNode) return [];
    return $f347e48613385d9c$var$closestDataStack(node.parentNode);
}
function $f347e48613385d9c$var$mergeProxies(objects) {
    return new Proxy({
        objects: objects
    }, $f347e48613385d9c$var$mergeProxyTrap);
}
var $f347e48613385d9c$var$mergeProxyTrap = {
    ownKeys ({ objects: objects }) {
        return Array.from(new Set(objects.flatMap((i)=>Object.keys(i))));
    },
    has ({ objects: objects }, name) {
        if (name == Symbol.unscopables) return false;
        return objects.some((obj)=>Object.prototype.hasOwnProperty.call(obj, name) || Reflect.has(obj, name));
    },
    get ({ objects: objects }, name, thisProxy) {
        if (name == "toJSON") return $f347e48613385d9c$var$collapseProxies;
        return Reflect.get(objects.find((obj)=>Reflect.has(obj, name)) || {}, name, thisProxy);
    },
    set ({ objects: objects }, name, value, thisProxy) {
        const target = objects.find((obj)=>Object.prototype.hasOwnProperty.call(obj, name)) || objects[objects.length - 1];
        const descriptor = Object.getOwnPropertyDescriptor(target, name);
        if (descriptor?.set && descriptor?.get) return descriptor.set.call(thisProxy, value) || true;
        return Reflect.set(target, name, value);
    }
};
function $f347e48613385d9c$var$collapseProxies() {
    let keys = Reflect.ownKeys(this);
    return keys.reduce((acc, key)=>{
        acc[key] = Reflect.get(this, key);
        return acc;
    }, {});
}
// packages/alpinejs/src/interceptor.js
function $f347e48613385d9c$var$initInterceptors(data2) {
    let isObject2 = (val)=>typeof val === "object" && !Array.isArray(val) && val !== null;
    let recurse = (obj, basePath = "")=>{
        Object.entries(Object.getOwnPropertyDescriptors(obj)).forEach(([key, { value: value, enumerable: enumerable }])=>{
            if (enumerable === false || value === void 0) return;
            if (typeof value === "object" && value !== null && value.__v_skip) return;
            let path = basePath === "" ? key : `${basePath}.${key}`;
            if (typeof value === "object" && value !== null && value._x_interceptor) obj[key] = value.initialize(data2, path, key);
            else if (isObject2(value) && value !== obj && !(value instanceof Element)) recurse(value, path);
        });
    };
    return recurse(data2);
}
function $f347e48613385d9c$var$interceptor(callback, mutateObj = ()=>{}) {
    let obj = {
        initialValue: void 0,
        _x_interceptor: true,
        initialize (data2, path, key) {
            return callback(this.initialValue, ()=>$f347e48613385d9c$var$get(data2, path), (value)=>$f347e48613385d9c$var$set(data2, path, value), path, key);
        }
    };
    mutateObj(obj);
    return (initialValue)=>{
        if (typeof initialValue === "object" && initialValue !== null && initialValue._x_interceptor) {
            let initialize = obj.initialize.bind(obj);
            obj.initialize = (data2, path, key)=>{
                let innerValue = initialValue.initialize(data2, path, key);
                obj.initialValue = innerValue;
                return initialize(data2, path, key);
            };
        } else obj.initialValue = initialValue;
        return obj;
    };
}
function $f347e48613385d9c$var$get(obj, path) {
    return path.split(".").reduce((carry, segment)=>carry[segment], obj);
}
function $f347e48613385d9c$var$set(obj, path, value) {
    if (typeof path === "string") path = path.split(".");
    if (path.length === 1) obj[path[0]] = value;
    else if (path.length === 0) throw error;
    else {
        if (obj[path[0]]) return $f347e48613385d9c$var$set(obj[path[0]], path.slice(1), value);
        else {
            obj[path[0]] = {};
            return $f347e48613385d9c$var$set(obj[path[0]], path.slice(1), value);
        }
    }
}
// packages/alpinejs/src/magics.js
var $f347e48613385d9c$var$magics = {};
function $f347e48613385d9c$var$magic(name, callback) {
    $f347e48613385d9c$var$magics[name] = callback;
}
function $f347e48613385d9c$var$injectMagics(obj, el) {
    let memoizedUtilities = $f347e48613385d9c$var$getUtilities(el);
    Object.entries($f347e48613385d9c$var$magics).forEach(([name, callback])=>{
        Object.defineProperty(obj, `$${name}`, {
            get () {
                return callback(el, memoizedUtilities);
            },
            enumerable: false
        });
    });
    return obj;
}
function $f347e48613385d9c$var$getUtilities(el) {
    let [utilities, cleanup2] = $f347e48613385d9c$var$getElementBoundUtilities(el);
    let utils = {
        interceptor: $f347e48613385d9c$var$interceptor,
        ...utilities
    };
    $f347e48613385d9c$var$onElRemoved(el, cleanup2);
    return utils;
}
// packages/alpinejs/src/utils/error.js
function $f347e48613385d9c$var$tryCatch(el, expression, callback, ...args) {
    try {
        return callback(...args);
    } catch (e) {
        $f347e48613385d9c$var$handleError(e, el, expression);
    }
}
function $f347e48613385d9c$var$handleError(error2, el, expression) {
    error2 = Object.assign(error2 ?? {
        message: "No error message given."
    }, {
        el: el,
        expression: expression
    });
    console.warn(`Alpine Expression Error: ${error2.message}

${expression ? 'Expression: "' + expression + '"\n\n' : ""}`, el);
    setTimeout(()=>{
        throw error2;
    }, 0);
}
// packages/alpinejs/src/evaluator.js
var $f347e48613385d9c$var$shouldAutoEvaluateFunctions = true;
function $f347e48613385d9c$var$dontAutoEvaluateFunctions(callback) {
    let cache = $f347e48613385d9c$var$shouldAutoEvaluateFunctions;
    $f347e48613385d9c$var$shouldAutoEvaluateFunctions = false;
    let result = callback();
    $f347e48613385d9c$var$shouldAutoEvaluateFunctions = cache;
    return result;
}
function $f347e48613385d9c$var$evaluate(el, expression, extras = {}) {
    let result;
    $f347e48613385d9c$var$evaluateLater(el, expression)((value)=>result = value, extras);
    return result;
}
function $f347e48613385d9c$var$evaluateLater(...args) {
    return $f347e48613385d9c$var$theEvaluatorFunction(...args);
}
var $f347e48613385d9c$var$theEvaluatorFunction = $f347e48613385d9c$var$normalEvaluator;
function $f347e48613385d9c$var$setEvaluator(newEvaluator) {
    $f347e48613385d9c$var$theEvaluatorFunction = newEvaluator;
}
function $f347e48613385d9c$var$normalEvaluator(el, expression) {
    let overriddenMagics = {};
    $f347e48613385d9c$var$injectMagics(overriddenMagics, el);
    let dataStack = [
        overriddenMagics,
        ...$f347e48613385d9c$var$closestDataStack(el)
    ];
    let evaluator = typeof expression === "function" ? $f347e48613385d9c$var$generateEvaluatorFromFunction(dataStack, expression) : $f347e48613385d9c$var$generateEvaluatorFromString(dataStack, expression, el);
    return $f347e48613385d9c$var$tryCatch.bind(null, el, expression, evaluator);
}
function $f347e48613385d9c$var$generateEvaluatorFromFunction(dataStack, func) {
    return (receiver = ()=>{}, { scope: scope2 = {}, params: params = [] } = {})=>{
        let result = func.apply($f347e48613385d9c$var$mergeProxies([
            scope2,
            ...dataStack
        ]), params);
        $f347e48613385d9c$var$runIfTypeOfFunction(receiver, result);
    };
}
var $f347e48613385d9c$var$evaluatorMemo = {};
function $f347e48613385d9c$var$generateFunctionFromString(expression, el) {
    if ($f347e48613385d9c$var$evaluatorMemo[expression]) return $f347e48613385d9c$var$evaluatorMemo[expression];
    let AsyncFunction = Object.getPrototypeOf(async function() {}).constructor;
    let rightSideSafeExpression = /^[\n\s]*if.*\(.*\)/.test(expression.trim()) || /^(let|const)\s/.test(expression.trim()) ? `(async()=>{ ${expression} })()` : expression;
    const safeAsyncFunction = ()=>{
        try {
            let func2 = new AsyncFunction([
                "__self",
                "scope"
            ], `with (scope) { __self.result = ${rightSideSafeExpression} }; __self.finished = true; return __self.result;`);
            Object.defineProperty(func2, "name", {
                value: `[Alpine] ${expression}`
            });
            return func2;
        } catch (error2) {
            $f347e48613385d9c$var$handleError(error2, el, expression);
            return Promise.resolve();
        }
    };
    let func = safeAsyncFunction();
    $f347e48613385d9c$var$evaluatorMemo[expression] = func;
    return func;
}
function $f347e48613385d9c$var$generateEvaluatorFromString(dataStack, expression, el) {
    let func = $f347e48613385d9c$var$generateFunctionFromString(expression, el);
    return (receiver = ()=>{}, { scope: scope2 = {}, params: params = [] } = {})=>{
        func.result = void 0;
        func.finished = false;
        let completeScope = $f347e48613385d9c$var$mergeProxies([
            scope2,
            ...dataStack
        ]);
        if (typeof func === "function") {
            let promise = func(func, completeScope).catch((error2)=>$f347e48613385d9c$var$handleError(error2, el, expression));
            if (func.finished) {
                $f347e48613385d9c$var$runIfTypeOfFunction(receiver, func.result, completeScope, params, el);
                func.result = void 0;
            } else promise.then((result)=>{
                $f347e48613385d9c$var$runIfTypeOfFunction(receiver, result, completeScope, params, el);
            }).catch((error2)=>$f347e48613385d9c$var$handleError(error2, el, expression)).finally(()=>func.result = void 0);
        }
    };
}
function $f347e48613385d9c$var$runIfTypeOfFunction(receiver, value, scope2, params, el) {
    if ($f347e48613385d9c$var$shouldAutoEvaluateFunctions && typeof value === "function") {
        let result = value.apply(scope2, params);
        if (result instanceof Promise) result.then((i)=>$f347e48613385d9c$var$runIfTypeOfFunction(receiver, i, scope2, params)).catch((error2)=>$f347e48613385d9c$var$handleError(error2, el, value));
        else receiver(result);
    } else if (typeof value === "object" && value instanceof Promise) value.then((i)=>receiver(i));
    else receiver(value);
}
// packages/alpinejs/src/directives.js
var $f347e48613385d9c$var$prefixAsString = "x-";
function $f347e48613385d9c$var$prefix(subject = "") {
    return $f347e48613385d9c$var$prefixAsString + subject;
}
function $f347e48613385d9c$var$setPrefix(newPrefix) {
    $f347e48613385d9c$var$prefixAsString = newPrefix;
}
var $f347e48613385d9c$var$directiveHandlers = {};
function $f347e48613385d9c$var$directive(name, callback) {
    $f347e48613385d9c$var$directiveHandlers[name] = callback;
    return {
        before (directive2) {
            if (!$f347e48613385d9c$var$directiveHandlers[directive2]) {
                console.warn(String.raw`Cannot find directive \`${directive2}\`. \`${name}\` will use the default order of execution`);
                return;
            }
            const pos = $f347e48613385d9c$var$directiveOrder.indexOf(directive2);
            $f347e48613385d9c$var$directiveOrder.splice(pos >= 0 ? pos : $f347e48613385d9c$var$directiveOrder.indexOf("DEFAULT"), 0, name);
        }
    };
}
function $f347e48613385d9c$var$directiveExists(name) {
    return Object.keys($f347e48613385d9c$var$directiveHandlers).includes(name);
}
function $f347e48613385d9c$var$directives(el, attributes, originalAttributeOverride) {
    attributes = Array.from(attributes);
    if (el._x_virtualDirectives) {
        let vAttributes = Object.entries(el._x_virtualDirectives).map(([name, value])=>({
                name: name,
                value: value
            }));
        let staticAttributes = $f347e48613385d9c$var$attributesOnly(vAttributes);
        vAttributes = vAttributes.map((attribute)=>{
            if (staticAttributes.find((attr)=>attr.name === attribute.name)) return {
                name: `x-bind:${attribute.name}`,
                value: `"${attribute.value}"`
            };
            return attribute;
        });
        attributes = attributes.concat(vAttributes);
    }
    let transformedAttributeMap = {};
    let directives2 = attributes.map($f347e48613385d9c$var$toTransformedAttributes((newName, oldName)=>transformedAttributeMap[newName] = oldName)).filter($f347e48613385d9c$var$outNonAlpineAttributes).map($f347e48613385d9c$var$toParsedDirectives(transformedAttributeMap, originalAttributeOverride)).sort($f347e48613385d9c$var$byPriority);
    return directives2.map((directive2)=>{
        return $f347e48613385d9c$var$getDirectiveHandler(el, directive2);
    });
}
function $f347e48613385d9c$var$attributesOnly(attributes) {
    return Array.from(attributes).map($f347e48613385d9c$var$toTransformedAttributes()).filter((attr)=>!$f347e48613385d9c$var$outNonAlpineAttributes(attr));
}
var $f347e48613385d9c$var$isDeferringHandlers = false;
var $f347e48613385d9c$var$directiveHandlerStacks = /* @__PURE__ */ new Map();
var $f347e48613385d9c$var$currentHandlerStackKey = Symbol();
function $f347e48613385d9c$var$deferHandlingDirectives(callback) {
    $f347e48613385d9c$var$isDeferringHandlers = true;
    let key = Symbol();
    $f347e48613385d9c$var$currentHandlerStackKey = key;
    $f347e48613385d9c$var$directiveHandlerStacks.set(key, []);
    let flushHandlers = ()=>{
        while($f347e48613385d9c$var$directiveHandlerStacks.get(key).length)$f347e48613385d9c$var$directiveHandlerStacks.get(key).shift()();
        $f347e48613385d9c$var$directiveHandlerStacks.delete(key);
    };
    let stopDeferring = ()=>{
        $f347e48613385d9c$var$isDeferringHandlers = false;
        flushHandlers();
    };
    callback(flushHandlers);
    stopDeferring();
}
function $f347e48613385d9c$var$getElementBoundUtilities(el) {
    let cleanups = [];
    let cleanup2 = (callback)=>cleanups.push(callback);
    let [effect3, cleanupEffect] = $f347e48613385d9c$var$elementBoundEffect(el);
    cleanups.push(cleanupEffect);
    let utilities = {
        Alpine: $f347e48613385d9c$var$alpine_default,
        effect: effect3,
        cleanup: cleanup2,
        evaluateLater: $f347e48613385d9c$var$evaluateLater.bind($f347e48613385d9c$var$evaluateLater, el),
        evaluate: $f347e48613385d9c$var$evaluate.bind($f347e48613385d9c$var$evaluate, el)
    };
    let doCleanup = ()=>cleanups.forEach((i)=>i());
    return [
        utilities,
        doCleanup
    ];
}
function $f347e48613385d9c$var$getDirectiveHandler(el, directive2) {
    let noop = ()=>{};
    let handler4 = $f347e48613385d9c$var$directiveHandlers[directive2.type] || noop;
    let [utilities, cleanup2] = $f347e48613385d9c$var$getElementBoundUtilities(el);
    $f347e48613385d9c$var$onAttributeRemoved(el, directive2.original, cleanup2);
    let fullHandler = ()=>{
        if (el._x_ignore || el._x_ignoreSelf) return;
        handler4.inline && handler4.inline(el, directive2, utilities);
        handler4 = handler4.bind(handler4, el, directive2, utilities);
        $f347e48613385d9c$var$isDeferringHandlers ? $f347e48613385d9c$var$directiveHandlerStacks.get($f347e48613385d9c$var$currentHandlerStackKey).push(handler4) : handler4();
    };
    fullHandler.runCleanups = cleanup2;
    return fullHandler;
}
var $f347e48613385d9c$var$startingWith = (subject, replacement)=>({ name: name, value: value })=>{
        if (name.startsWith(subject)) name = name.replace(subject, replacement);
        return {
            name: name,
            value: value
        };
    };
var $f347e48613385d9c$var$into = (i)=>i;
function $f347e48613385d9c$var$toTransformedAttributes(callback = ()=>{}) {
    return ({ name: name, value: value })=>{
        let { name: newName, value: newValue } = $f347e48613385d9c$var$attributeTransformers.reduce((carry, transform)=>{
            return transform(carry);
        }, {
            name: name,
            value: value
        });
        if (newName !== name) callback(newName, name);
        return {
            name: newName,
            value: newValue
        };
    };
}
var $f347e48613385d9c$var$attributeTransformers = [];
function $f347e48613385d9c$var$mapAttributes(callback) {
    $f347e48613385d9c$var$attributeTransformers.push(callback);
}
function $f347e48613385d9c$var$outNonAlpineAttributes({ name: name }) {
    return $f347e48613385d9c$var$alpineAttributeRegex().test(name);
}
var $f347e48613385d9c$var$alpineAttributeRegex = ()=>new RegExp(`^${$f347e48613385d9c$var$prefixAsString}([^:^.]+)\\b`);
function $f347e48613385d9c$var$toParsedDirectives(transformedAttributeMap, originalAttributeOverride) {
    return ({ name: name, value: value })=>{
        let typeMatch = name.match($f347e48613385d9c$var$alpineAttributeRegex());
        let valueMatch = name.match(/:([a-zA-Z0-9\-_:]+)/);
        let modifiers = name.match(/\.[^.\]]+(?=[^\]]*$)/g) || [];
        let original = originalAttributeOverride || transformedAttributeMap[name] || name;
        return {
            type: typeMatch ? typeMatch[1] : null,
            value: valueMatch ? valueMatch[1] : null,
            modifiers: modifiers.map((i)=>i.replace(".", "")),
            expression: value,
            original: original
        };
    };
}
var $f347e48613385d9c$var$DEFAULT = "DEFAULT";
var $f347e48613385d9c$var$directiveOrder = [
    "ignore",
    "ref",
    "data",
    "id",
    "anchor",
    "bind",
    "init",
    "for",
    "model",
    "modelable",
    "transition",
    "show",
    "if",
    $f347e48613385d9c$var$DEFAULT,
    "teleport"
];
function $f347e48613385d9c$var$byPriority(a, b) {
    let typeA = $f347e48613385d9c$var$directiveOrder.indexOf(a.type) === -1 ? $f347e48613385d9c$var$DEFAULT : a.type;
    let typeB = $f347e48613385d9c$var$directiveOrder.indexOf(b.type) === -1 ? $f347e48613385d9c$var$DEFAULT : b.type;
    return $f347e48613385d9c$var$directiveOrder.indexOf(typeA) - $f347e48613385d9c$var$directiveOrder.indexOf(typeB);
}
// packages/alpinejs/src/utils/dispatch.js
function $f347e48613385d9c$var$dispatch(el, name, detail = {}) {
    el.dispatchEvent(new CustomEvent(name, {
        detail: detail,
        bubbles: true,
        // Allows events to pass the shadow DOM barrier.
        composed: true,
        cancelable: true
    }));
}
// packages/alpinejs/src/utils/walk.js
function $f347e48613385d9c$var$walk(el, callback) {
    if (typeof ShadowRoot === "function" && el instanceof ShadowRoot) {
        Array.from(el.children).forEach((el2)=>$f347e48613385d9c$var$walk(el2, callback));
        return;
    }
    let skip = false;
    callback(el, ()=>skip = true);
    if (skip) return;
    let node = el.firstElementChild;
    while(node){
        $f347e48613385d9c$var$walk(node, callback, false);
        node = node.nextElementSibling;
    }
}
// packages/alpinejs/src/utils/warn.js
function $f347e48613385d9c$var$warn(message, ...args) {
    console.warn(`Alpine Warning: ${message}`, ...args);
}
// packages/alpinejs/src/lifecycle.js
var $f347e48613385d9c$var$started = false;
function $f347e48613385d9c$var$start() {
    if ($f347e48613385d9c$var$started) $f347e48613385d9c$var$warn("Alpine has already been initialized on this page. Calling Alpine.start() more than once can cause problems.");
    $f347e48613385d9c$var$started = true;
    if (!document.body) $f347e48613385d9c$var$warn("Unable to initialize. Trying to load Alpine before `<body>` is available. Did you forget to add `defer` in Alpine's `<script>` tag?");
    $f347e48613385d9c$var$dispatch(document, "alpine:init");
    $f347e48613385d9c$var$dispatch(document, "alpine:initializing");
    $f347e48613385d9c$var$startObservingMutations();
    $f347e48613385d9c$var$onElAdded((el)=>$f347e48613385d9c$var$initTree(el, $f347e48613385d9c$var$walk));
    $f347e48613385d9c$var$onElRemoved((el)=>$f347e48613385d9c$var$destroyTree(el));
    $f347e48613385d9c$var$onAttributesAdded((el, attrs)=>{
        $f347e48613385d9c$var$directives(el, attrs).forEach((handle)=>handle());
    });
    let outNestedComponents = (el)=>!$f347e48613385d9c$var$closestRoot(el.parentElement, true);
    Array.from(document.querySelectorAll($f347e48613385d9c$var$allSelectors().join(","))).filter(outNestedComponents).forEach((el)=>{
        $f347e48613385d9c$var$initTree(el);
    });
    $f347e48613385d9c$var$dispatch(document, "alpine:initialized");
    setTimeout(()=>{
        $f347e48613385d9c$var$warnAboutMissingPlugins();
    });
}
var $f347e48613385d9c$var$rootSelectorCallbacks = [];
var $f347e48613385d9c$var$initSelectorCallbacks = [];
function $f347e48613385d9c$var$rootSelectors() {
    return $f347e48613385d9c$var$rootSelectorCallbacks.map((fn)=>fn());
}
function $f347e48613385d9c$var$allSelectors() {
    return $f347e48613385d9c$var$rootSelectorCallbacks.concat($f347e48613385d9c$var$initSelectorCallbacks).map((fn)=>fn());
}
function $f347e48613385d9c$var$addRootSelector(selectorCallback) {
    $f347e48613385d9c$var$rootSelectorCallbacks.push(selectorCallback);
}
function $f347e48613385d9c$var$addInitSelector(selectorCallback) {
    $f347e48613385d9c$var$initSelectorCallbacks.push(selectorCallback);
}
function $f347e48613385d9c$var$closestRoot(el, includeInitSelectors = false) {
    return $f347e48613385d9c$var$findClosest(el, (element)=>{
        const selectors = includeInitSelectors ? $f347e48613385d9c$var$allSelectors() : $f347e48613385d9c$var$rootSelectors();
        if (selectors.some((selector)=>element.matches(selector))) return true;
    });
}
function $f347e48613385d9c$var$findClosest(el, callback) {
    if (!el) return;
    if (callback(el)) return el;
    if (el._x_teleportBack) el = el._x_teleportBack;
    if (!el.parentElement) return;
    return $f347e48613385d9c$var$findClosest(el.parentElement, callback);
}
function $f347e48613385d9c$var$isRoot(el) {
    return $f347e48613385d9c$var$rootSelectors().some((selector)=>el.matches(selector));
}
var $f347e48613385d9c$var$initInterceptors2 = [];
function $f347e48613385d9c$var$interceptInit(callback) {
    $f347e48613385d9c$var$initInterceptors2.push(callback);
}
var $f347e48613385d9c$var$markerDispenser = 1;
function $f347e48613385d9c$var$initTree(el, walker = $f347e48613385d9c$var$walk, intercept = ()=>{}) {
    if ($f347e48613385d9c$var$findClosest(el, (i)=>i._x_ignore)) return;
    $f347e48613385d9c$var$deferHandlingDirectives(()=>{
        walker(el, (el2, skip)=>{
            if (el2._x_marker) return;
            intercept(el2, skip);
            $f347e48613385d9c$var$initInterceptors2.forEach((i)=>i(el2, skip));
            $f347e48613385d9c$var$directives(el2, el2.attributes).forEach((handle)=>handle());
            if (!el2._x_ignore) el2._x_marker = $f347e48613385d9c$var$markerDispenser++;
            el2._x_ignore && skip();
        });
    });
}
function $f347e48613385d9c$var$destroyTree(root, walker = $f347e48613385d9c$var$walk) {
    walker(root, (el)=>{
        $f347e48613385d9c$var$cleanupElement(el);
        $f347e48613385d9c$var$cleanupAttributes(el);
        delete el._x_marker;
    });
}
function $f347e48613385d9c$var$warnAboutMissingPlugins() {
    let pluginDirectives = [
        [
            "ui",
            "dialog",
            [
                "[x-dialog], [x-popover]"
            ]
        ],
        [
            "anchor",
            "anchor",
            [
                "[x-anchor]"
            ]
        ],
        [
            "sort",
            "sort",
            [
                "[x-sort]"
            ]
        ]
    ];
    pluginDirectives.forEach(([plugin2, directive2, selectors])=>{
        if ($f347e48613385d9c$var$directiveExists(directive2)) return;
        selectors.some((selector)=>{
            if (document.querySelector(selector)) {
                $f347e48613385d9c$var$warn(`found "${selector}", but missing ${plugin2} plugin`);
                return true;
            }
        });
    });
}
// packages/alpinejs/src/nextTick.js
var $f347e48613385d9c$var$tickStack = [];
var $f347e48613385d9c$var$isHolding = false;
function $f347e48613385d9c$var$nextTick(callback = ()=>{}) {
    queueMicrotask(()=>{
        $f347e48613385d9c$var$isHolding || setTimeout(()=>{
            $f347e48613385d9c$var$releaseNextTicks();
        });
    });
    return new Promise((res)=>{
        $f347e48613385d9c$var$tickStack.push(()=>{
            callback();
            res();
        });
    });
}
function $f347e48613385d9c$var$releaseNextTicks() {
    $f347e48613385d9c$var$isHolding = false;
    while($f347e48613385d9c$var$tickStack.length)$f347e48613385d9c$var$tickStack.shift()();
}
function $f347e48613385d9c$var$holdNextTicks() {
    $f347e48613385d9c$var$isHolding = true;
}
// packages/alpinejs/src/utils/classes.js
function $f347e48613385d9c$var$setClasses(el, value) {
    if (Array.isArray(value)) return $f347e48613385d9c$var$setClassesFromString(el, value.join(" "));
    else if (typeof value === "object" && value !== null) return $f347e48613385d9c$var$setClassesFromObject(el, value);
    else if (typeof value === "function") return $f347e48613385d9c$var$setClasses(el, value());
    return $f347e48613385d9c$var$setClassesFromString(el, value);
}
function $f347e48613385d9c$var$setClassesFromString(el, classString) {
    let split = (classString2)=>classString2.split(" ").filter(Boolean);
    let missingClasses = (classString2)=>classString2.split(" ").filter((i)=>!el.classList.contains(i)).filter(Boolean);
    let addClassesAndReturnUndo = (classes)=>{
        el.classList.add(...classes);
        return ()=>{
            el.classList.remove(...classes);
        };
    };
    classString = classString === true ? classString = "" : classString || "";
    return addClassesAndReturnUndo(missingClasses(classString));
}
function $f347e48613385d9c$var$setClassesFromObject(el, classObject) {
    let split = (classString)=>classString.split(" ").filter(Boolean);
    let forAdd = Object.entries(classObject).flatMap(([classString, bool])=>bool ? split(classString) : false).filter(Boolean);
    let forRemove = Object.entries(classObject).flatMap(([classString, bool])=>!bool ? split(classString) : false).filter(Boolean);
    let added = [];
    let removed = [];
    forRemove.forEach((i)=>{
        if (el.classList.contains(i)) {
            el.classList.remove(i);
            removed.push(i);
        }
    });
    forAdd.forEach((i)=>{
        if (!el.classList.contains(i)) {
            el.classList.add(i);
            added.push(i);
        }
    });
    return ()=>{
        removed.forEach((i)=>el.classList.add(i));
        added.forEach((i)=>el.classList.remove(i));
    };
}
// packages/alpinejs/src/utils/styles.js
function $f347e48613385d9c$var$setStyles(el, value) {
    if (typeof value === "object" && value !== null) return $f347e48613385d9c$var$setStylesFromObject(el, value);
    return $f347e48613385d9c$var$setStylesFromString(el, value);
}
function $f347e48613385d9c$var$setStylesFromObject(el, value) {
    let previousStyles = {};
    Object.entries(value).forEach(([key, value2])=>{
        previousStyles[key] = el.style[key];
        if (!key.startsWith("--")) key = $f347e48613385d9c$var$kebabCase(key);
        el.style.setProperty(key, value2);
    });
    setTimeout(()=>{
        if (el.style.length === 0) el.removeAttribute("style");
    });
    return ()=>{
        $f347e48613385d9c$var$setStyles(el, previousStyles);
    };
}
function $f347e48613385d9c$var$setStylesFromString(el, value) {
    let cache = el.getAttribute("style", value);
    el.setAttribute("style", value);
    return ()=>{
        el.setAttribute("style", cache || "");
    };
}
function $f347e48613385d9c$var$kebabCase(subject) {
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
// packages/alpinejs/src/utils/once.js
function $f347e48613385d9c$var$once(callback, fallback = ()=>{}) {
    let called = false;
    return function() {
        if (!called) {
            called = true;
            callback.apply(this, arguments);
        } else fallback.apply(this, arguments);
    };
}
// packages/alpinejs/src/directives/x-transition.js
$f347e48613385d9c$var$directive("transition", (el, { value: value, modifiers: modifiers, expression: expression }, { evaluate: evaluate2 })=>{
    if (typeof expression === "function") expression = evaluate2(expression);
    if (expression === false) return;
    if (!expression || typeof expression === "boolean") $f347e48613385d9c$var$registerTransitionsFromHelper(el, modifiers, value);
    else $f347e48613385d9c$var$registerTransitionsFromClassString(el, expression, value);
});
function $f347e48613385d9c$var$registerTransitionsFromClassString(el, classString, stage) {
    $f347e48613385d9c$var$registerTransitionObject(el, $f347e48613385d9c$var$setClasses, "");
    let directiveStorageMap = {
        "enter": (classes)=>{
            el._x_transition.enter.during = classes;
        },
        "enter-start": (classes)=>{
            el._x_transition.enter.start = classes;
        },
        "enter-end": (classes)=>{
            el._x_transition.enter.end = classes;
        },
        "leave": (classes)=>{
            el._x_transition.leave.during = classes;
        },
        "leave-start": (classes)=>{
            el._x_transition.leave.start = classes;
        },
        "leave-end": (classes)=>{
            el._x_transition.leave.end = classes;
        }
    };
    directiveStorageMap[stage](classString);
}
function $f347e48613385d9c$var$registerTransitionsFromHelper(el, modifiers, stage) {
    $f347e48613385d9c$var$registerTransitionObject(el, $f347e48613385d9c$var$setStyles);
    let doesntSpecify = !modifiers.includes("in") && !modifiers.includes("out") && !stage;
    let transitioningIn = doesntSpecify || modifiers.includes("in") || [
        "enter"
    ].includes(stage);
    let transitioningOut = doesntSpecify || modifiers.includes("out") || [
        "leave"
    ].includes(stage);
    if (modifiers.includes("in") && !doesntSpecify) modifiers = modifiers.filter((i, index)=>index < modifiers.indexOf("out"));
    if (modifiers.includes("out") && !doesntSpecify) modifiers = modifiers.filter((i, index)=>index > modifiers.indexOf("out"));
    let wantsAll = !modifiers.includes("opacity") && !modifiers.includes("scale");
    let wantsOpacity = wantsAll || modifiers.includes("opacity");
    let wantsScale = wantsAll || modifiers.includes("scale");
    let opacityValue = wantsOpacity ? 0 : 1;
    let scaleValue = wantsScale ? $f347e48613385d9c$var$modifierValue(modifiers, "scale", 95) / 100 : 1;
    let delay = $f347e48613385d9c$var$modifierValue(modifiers, "delay", 0) / 1e3;
    let origin = $f347e48613385d9c$var$modifierValue(modifiers, "origin", "center");
    let property = "opacity, transform";
    let durationIn = $f347e48613385d9c$var$modifierValue(modifiers, "duration", 150) / 1e3;
    let durationOut = $f347e48613385d9c$var$modifierValue(modifiers, "duration", 75) / 1e3;
    let easing = `cubic-bezier(0.4, 0.0, 0.2, 1)`;
    if (transitioningIn) {
        el._x_transition.enter.during = {
            transformOrigin: origin,
            transitionDelay: `${delay}s`,
            transitionProperty: property,
            transitionDuration: `${durationIn}s`,
            transitionTimingFunction: easing
        };
        el._x_transition.enter.start = {
            opacity: opacityValue,
            transform: `scale(${scaleValue})`
        };
        el._x_transition.enter.end = {
            opacity: 1,
            transform: `scale(1)`
        };
    }
    if (transitioningOut) {
        el._x_transition.leave.during = {
            transformOrigin: origin,
            transitionDelay: `${delay}s`,
            transitionProperty: property,
            transitionDuration: `${durationOut}s`,
            transitionTimingFunction: easing
        };
        el._x_transition.leave.start = {
            opacity: 1,
            transform: `scale(1)`
        };
        el._x_transition.leave.end = {
            opacity: opacityValue,
            transform: `scale(${scaleValue})`
        };
    }
}
function $f347e48613385d9c$var$registerTransitionObject(el, setFunction, defaultValue = {}) {
    if (!el._x_transition) el._x_transition = {
        enter: {
            during: defaultValue,
            start: defaultValue,
            end: defaultValue
        },
        leave: {
            during: defaultValue,
            start: defaultValue,
            end: defaultValue
        },
        in (before = ()=>{}, after = ()=>{}) {
            $f347e48613385d9c$var$transition(el, setFunction, {
                during: this.enter.during,
                start: this.enter.start,
                end: this.enter.end
            }, before, after);
        },
        out (before = ()=>{}, after = ()=>{}) {
            $f347e48613385d9c$var$transition(el, setFunction, {
                during: this.leave.during,
                start: this.leave.start,
                end: this.leave.end
            }, before, after);
        }
    };
}
window.Element.prototype._x_toggleAndCascadeWithTransitions = function(el, value, show, hide) {
    const nextTick2 = document.visibilityState === "visible" ? requestAnimationFrame : setTimeout;
    let clickAwayCompatibleShow = ()=>nextTick2(show);
    if (value) {
        if (el._x_transition && (el._x_transition.enter || el._x_transition.leave)) el._x_transition.enter && (Object.entries(el._x_transition.enter.during).length || Object.entries(el._x_transition.enter.start).length || Object.entries(el._x_transition.enter.end).length) ? el._x_transition.in(show) : clickAwayCompatibleShow();
        else el._x_transition ? el._x_transition.in(show) : clickAwayCompatibleShow();
        return;
    }
    el._x_hidePromise = el._x_transition ? new Promise((resolve, reject)=>{
        el._x_transition.out(()=>{}, ()=>resolve(hide));
        el._x_transitioning && el._x_transitioning.beforeCancel(()=>reject({
                isFromCancelledTransition: true
            }));
    }) : Promise.resolve(hide);
    queueMicrotask(()=>{
        let closest = $f347e48613385d9c$var$closestHide(el);
        if (closest) {
            if (!closest._x_hideChildren) closest._x_hideChildren = [];
            closest._x_hideChildren.push(el);
        } else nextTick2(()=>{
            let hideAfterChildren = (el2)=>{
                let carry = Promise.all([
                    el2._x_hidePromise,
                    ...(el2._x_hideChildren || []).map(hideAfterChildren)
                ]).then(([i])=>i?.());
                delete el2._x_hidePromise;
                delete el2._x_hideChildren;
                return carry;
            };
            hideAfterChildren(el).catch((e)=>{
                if (!e.isFromCancelledTransition) throw e;
            });
        });
    });
};
function $f347e48613385d9c$var$closestHide(el) {
    let parent = el.parentNode;
    if (!parent) return;
    return parent._x_hidePromise ? parent : $f347e48613385d9c$var$closestHide(parent);
}
function $f347e48613385d9c$var$transition(el, setFunction, { during: during, start: start2, end: end } = {}, before = ()=>{}, after = ()=>{}) {
    if (el._x_transitioning) el._x_transitioning.cancel();
    if (Object.keys(during).length === 0 && Object.keys(start2).length === 0 && Object.keys(end).length === 0) {
        before();
        after();
        return;
    }
    let undoStart, undoDuring, undoEnd;
    $f347e48613385d9c$var$performTransition(el, {
        start () {
            undoStart = setFunction(el, start2);
        },
        during () {
            undoDuring = setFunction(el, during);
        },
        before: before,
        end () {
            undoStart();
            undoEnd = setFunction(el, end);
        },
        after: after,
        cleanup () {
            undoDuring();
            undoEnd();
        }
    });
}
function $f347e48613385d9c$var$performTransition(el, stages) {
    let interrupted, reachedBefore, reachedEnd;
    let finish = $f347e48613385d9c$var$once(()=>{
        $f347e48613385d9c$var$mutateDom(()=>{
            interrupted = true;
            if (!reachedBefore) stages.before();
            if (!reachedEnd) {
                stages.end();
                $f347e48613385d9c$var$releaseNextTicks();
            }
            stages.after();
            if (el.isConnected) stages.cleanup();
            delete el._x_transitioning;
        });
    });
    el._x_transitioning = {
        beforeCancels: [],
        beforeCancel (callback) {
            this.beforeCancels.push(callback);
        },
        cancel: $f347e48613385d9c$var$once(function() {
            while(this.beforeCancels.length)this.beforeCancels.shift()();
            finish();
        }),
        finish: finish
    };
    $f347e48613385d9c$var$mutateDom(()=>{
        stages.start();
        stages.during();
    });
    $f347e48613385d9c$var$holdNextTicks();
    requestAnimationFrame(()=>{
        if (interrupted) return;
        let duration = Number(getComputedStyle(el).transitionDuration.replace(/,.*/, "").replace("s", "")) * 1e3;
        let delay = Number(getComputedStyle(el).transitionDelay.replace(/,.*/, "").replace("s", "")) * 1e3;
        if (duration === 0) duration = Number(getComputedStyle(el).animationDuration.replace("s", "")) * 1e3;
        $f347e48613385d9c$var$mutateDom(()=>{
            stages.before();
        });
        reachedBefore = true;
        requestAnimationFrame(()=>{
            if (interrupted) return;
            $f347e48613385d9c$var$mutateDom(()=>{
                stages.end();
            });
            $f347e48613385d9c$var$releaseNextTicks();
            setTimeout(el._x_transitioning.finish, duration + delay);
            reachedEnd = true;
        });
    });
}
function $f347e48613385d9c$var$modifierValue(modifiers, key, fallback) {
    if (modifiers.indexOf(key) === -1) return fallback;
    const rawValue = modifiers[modifiers.indexOf(key) + 1];
    if (!rawValue) return fallback;
    if (key === "scale") {
        if (isNaN(rawValue)) return fallback;
    }
    if (key === "duration" || key === "delay") {
        let match = rawValue.match(/([0-9]+)ms/);
        if (match) return match[1];
    }
    if (key === "origin") {
        if ([
            "top",
            "right",
            "left",
            "center",
            "bottom"
        ].includes(modifiers[modifiers.indexOf(key) + 2])) return [
            rawValue,
            modifiers[modifiers.indexOf(key) + 2]
        ].join(" ");
    }
    return rawValue;
}
// packages/alpinejs/src/clone.js
var $f347e48613385d9c$var$isCloning = false;
function $f347e48613385d9c$var$skipDuringClone(callback, fallback = ()=>{}) {
    return (...args)=>$f347e48613385d9c$var$isCloning ? fallback(...args) : callback(...args);
}
function $f347e48613385d9c$var$onlyDuringClone(callback) {
    return (...args)=>$f347e48613385d9c$var$isCloning && callback(...args);
}
var $f347e48613385d9c$var$interceptors = [];
function $f347e48613385d9c$var$interceptClone(callback) {
    $f347e48613385d9c$var$interceptors.push(callback);
}
function $f347e48613385d9c$var$cloneNode(from, to) {
    $f347e48613385d9c$var$interceptors.forEach((i)=>i(from, to));
    $f347e48613385d9c$var$isCloning = true;
    $f347e48613385d9c$var$dontRegisterReactiveSideEffects(()=>{
        $f347e48613385d9c$var$initTree(to, (el, callback)=>{
            callback(el, ()=>{});
        });
    });
    $f347e48613385d9c$var$isCloning = false;
}
var $f347e48613385d9c$var$isCloningLegacy = false;
function $f347e48613385d9c$var$clone(oldEl, newEl) {
    if (!newEl._x_dataStack) newEl._x_dataStack = oldEl._x_dataStack;
    $f347e48613385d9c$var$isCloning = true;
    $f347e48613385d9c$var$isCloningLegacy = true;
    $f347e48613385d9c$var$dontRegisterReactiveSideEffects(()=>{
        $f347e48613385d9c$var$cloneTree(newEl);
    });
    $f347e48613385d9c$var$isCloning = false;
    $f347e48613385d9c$var$isCloningLegacy = false;
}
function $f347e48613385d9c$var$cloneTree(el) {
    let hasRunThroughFirstEl = false;
    let shallowWalker = (el2, callback)=>{
        $f347e48613385d9c$var$walk(el2, (el3, skip)=>{
            if (hasRunThroughFirstEl && $f347e48613385d9c$var$isRoot(el3)) return skip();
            hasRunThroughFirstEl = true;
            callback(el3, skip);
        });
    };
    $f347e48613385d9c$var$initTree(el, shallowWalker);
}
function $f347e48613385d9c$var$dontRegisterReactiveSideEffects(callback) {
    let cache = $f347e48613385d9c$var$effect;
    $f347e48613385d9c$var$overrideEffect((callback2, el)=>{
        let storedEffect = cache(callback2);
        $f347e48613385d9c$var$release(storedEffect);
        return ()=>{};
    });
    callback();
    $f347e48613385d9c$var$overrideEffect(cache);
}
// packages/alpinejs/src/utils/bind.js
function $f347e48613385d9c$var$bind(el, name, value, modifiers = []) {
    if (!el._x_bindings) el._x_bindings = $f347e48613385d9c$var$reactive({});
    el._x_bindings[name] = value;
    name = modifiers.includes("camel") ? $f347e48613385d9c$var$camelCase(name) : name;
    switch(name){
        case "value":
            $f347e48613385d9c$var$bindInputValue(el, value);
            break;
        case "style":
            $f347e48613385d9c$var$bindStyles(el, value);
            break;
        case "class":
            $f347e48613385d9c$var$bindClasses(el, value);
            break;
        case "selected":
        case "checked":
            $f347e48613385d9c$var$bindAttributeAndProperty(el, name, value);
            break;
        default:
            $f347e48613385d9c$var$bindAttribute(el, name, value);
            break;
    }
}
function $f347e48613385d9c$var$bindInputValue(el, value) {
    if ($f347e48613385d9c$var$isRadio(el)) {
        if (el.attributes.value === void 0) el.value = value;
        if (window.fromModel) {
            if (typeof value === "boolean") el.checked = $f347e48613385d9c$var$safeParseBoolean(el.value) === value;
            else el.checked = $f347e48613385d9c$var$checkedAttrLooseCompare(el.value, value);
        }
    } else if ($f347e48613385d9c$var$isCheckbox(el)) {
        if (Number.isInteger(value)) el.value = value;
        else if (!Array.isArray(value) && typeof value !== "boolean" && ![
            null,
            void 0
        ].includes(value)) el.value = String(value);
        else if (Array.isArray(value)) el.checked = value.some((val)=>$f347e48613385d9c$var$checkedAttrLooseCompare(val, el.value));
        else el.checked = !!value;
    } else if (el.tagName === "SELECT") $f347e48613385d9c$var$updateSelect(el, value);
    else {
        if (el.value === value) return;
        el.value = value === void 0 ? "" : value;
    }
}
function $f347e48613385d9c$var$bindClasses(el, value) {
    if (el._x_undoAddedClasses) el._x_undoAddedClasses();
    el._x_undoAddedClasses = $f347e48613385d9c$var$setClasses(el, value);
}
function $f347e48613385d9c$var$bindStyles(el, value) {
    if (el._x_undoAddedStyles) el._x_undoAddedStyles();
    el._x_undoAddedStyles = $f347e48613385d9c$var$setStyles(el, value);
}
function $f347e48613385d9c$var$bindAttributeAndProperty(el, name, value) {
    $f347e48613385d9c$var$bindAttribute(el, name, value);
    $f347e48613385d9c$var$setPropertyIfChanged(el, name, value);
}
function $f347e48613385d9c$var$bindAttribute(el, name, value) {
    if ([
        null,
        void 0,
        false
    ].includes(value) && $f347e48613385d9c$var$attributeShouldntBePreservedIfFalsy(name)) el.removeAttribute(name);
    else {
        if ($f347e48613385d9c$var$isBooleanAttr(name)) value = name;
        $f347e48613385d9c$var$setIfChanged(el, name, value);
    }
}
function $f347e48613385d9c$var$setIfChanged(el, attrName, value) {
    if (el.getAttribute(attrName) != value) el.setAttribute(attrName, value);
}
function $f347e48613385d9c$var$setPropertyIfChanged(el, propName, value) {
    if (el[propName] !== value) el[propName] = value;
}
function $f347e48613385d9c$var$updateSelect(el, value) {
    const arrayWrappedValue = [].concat(value).map((value2)=>{
        return value2 + "";
    });
    Array.from(el.options).forEach((option)=>{
        option.selected = arrayWrappedValue.includes(option.value);
    });
}
function $f347e48613385d9c$var$camelCase(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, (match, char)=>char.toUpperCase());
}
function $f347e48613385d9c$var$checkedAttrLooseCompare(valueA, valueB) {
    return valueA == valueB;
}
function $f347e48613385d9c$var$safeParseBoolean(rawValue) {
    if ([
        1,
        "1",
        "true",
        "on",
        "yes",
        true
    ].includes(rawValue)) return true;
    if ([
        0,
        "0",
        "false",
        "off",
        "no",
        false
    ].includes(rawValue)) return false;
    return rawValue ? Boolean(rawValue) : null;
}
var $f347e48613385d9c$var$booleanAttributes = /* @__PURE__ */ new Set([
    "allowfullscreen",
    "async",
    "autofocus",
    "autoplay",
    "checked",
    "controls",
    "default",
    "defer",
    "disabled",
    "formnovalidate",
    "inert",
    "ismap",
    "itemscope",
    "loop",
    "multiple",
    "muted",
    "nomodule",
    "novalidate",
    "open",
    "playsinline",
    "readonly",
    "required",
    "reversed",
    "selected",
    "shadowrootclonable",
    "shadowrootdelegatesfocus",
    "shadowrootserializable"
]);
function $f347e48613385d9c$var$isBooleanAttr(attrName) {
    return $f347e48613385d9c$var$booleanAttributes.has(attrName);
}
function $f347e48613385d9c$var$attributeShouldntBePreservedIfFalsy(name) {
    return ![
        "aria-pressed",
        "aria-checked",
        "aria-expanded",
        "aria-selected"
    ].includes(name);
}
function $f347e48613385d9c$var$getBinding(el, name, fallback) {
    if (el._x_bindings && el._x_bindings[name] !== void 0) return el._x_bindings[name];
    return $f347e48613385d9c$var$getAttributeBinding(el, name, fallback);
}
function $f347e48613385d9c$var$extractProp(el, name, fallback, extract = true) {
    if (el._x_bindings && el._x_bindings[name] !== void 0) return el._x_bindings[name];
    if (el._x_inlineBindings && el._x_inlineBindings[name] !== void 0) {
        let binding = el._x_inlineBindings[name];
        binding.extract = extract;
        return $f347e48613385d9c$var$dontAutoEvaluateFunctions(()=>{
            return $f347e48613385d9c$var$evaluate(el, binding.expression);
        });
    }
    return $f347e48613385d9c$var$getAttributeBinding(el, name, fallback);
}
function $f347e48613385d9c$var$getAttributeBinding(el, name, fallback) {
    let attr = el.getAttribute(name);
    if (attr === null) return typeof fallback === "function" ? fallback() : fallback;
    if (attr === "") return true;
    if ($f347e48613385d9c$var$isBooleanAttr(name)) return !![
        name,
        "true"
    ].includes(attr);
    return attr;
}
function $f347e48613385d9c$var$isCheckbox(el) {
    return el.type === "checkbox" || el.localName === "ui-checkbox" || el.localName === "ui-switch";
}
function $f347e48613385d9c$var$isRadio(el) {
    return el.type === "radio" || el.localName === "ui-radio";
}
// packages/alpinejs/src/utils/debounce.js
function $f347e48613385d9c$var$debounce(func, wait) {
    var timeout;
    return function() {
        var context = this, args = arguments;
        var later = function() {
            timeout = null;
            func.apply(context, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}
// packages/alpinejs/src/utils/throttle.js
function $f347e48613385d9c$var$throttle(func, limit) {
    let inThrottle;
    return function() {
        let context = this, args = arguments;
        if (!inThrottle) {
            func.apply(context, args);
            inThrottle = true;
            setTimeout(()=>inThrottle = false, limit);
        }
    };
}
// packages/alpinejs/src/entangle.js
function $f347e48613385d9c$var$entangle({ get: outerGet, set: outerSet }, { get: innerGet, set: innerSet }) {
    let firstRun = true;
    let outerHash;
    let innerHash;
    let reference = $f347e48613385d9c$var$effect(()=>{
        let outer = outerGet();
        let inner = innerGet();
        if (firstRun) {
            innerSet($f347e48613385d9c$var$cloneIfObject(outer));
            firstRun = false;
        } else {
            let outerHashLatest = JSON.stringify(outer);
            let innerHashLatest = JSON.stringify(inner);
            if (outerHashLatest !== outerHash) innerSet($f347e48613385d9c$var$cloneIfObject(outer));
            else if (outerHashLatest !== innerHashLatest) outerSet($f347e48613385d9c$var$cloneIfObject(inner));
        }
        outerHash = JSON.stringify(outerGet());
        innerHash = JSON.stringify(innerGet());
    });
    return ()=>{
        $f347e48613385d9c$var$release(reference);
    };
}
function $f347e48613385d9c$var$cloneIfObject(value) {
    return typeof value === "object" ? JSON.parse(JSON.stringify(value)) : value;
}
// packages/alpinejs/src/plugin.js
function $f347e48613385d9c$var$plugin(callback) {
    let callbacks = Array.isArray(callback) ? callback : [
        callback
    ];
    callbacks.forEach((i)=>i($f347e48613385d9c$var$alpine_default));
}
// packages/alpinejs/src/store.js
var $f347e48613385d9c$var$stores = {};
var $f347e48613385d9c$var$isReactive = false;
function $f347e48613385d9c$var$store(name, value) {
    if (!$f347e48613385d9c$var$isReactive) {
        $f347e48613385d9c$var$stores = $f347e48613385d9c$var$reactive($f347e48613385d9c$var$stores);
        $f347e48613385d9c$var$isReactive = true;
    }
    if (value === void 0) return $f347e48613385d9c$var$stores[name];
    $f347e48613385d9c$var$stores[name] = value;
    $f347e48613385d9c$var$initInterceptors($f347e48613385d9c$var$stores[name]);
    if (typeof value === "object" && value !== null && value.hasOwnProperty("init") && typeof value.init === "function") $f347e48613385d9c$var$stores[name].init();
}
function $f347e48613385d9c$var$getStores() {
    return $f347e48613385d9c$var$stores;
}
// packages/alpinejs/src/binds.js
var $f347e48613385d9c$var$binds = {};
function $f347e48613385d9c$var$bind2(name, bindings) {
    let getBindings = typeof bindings !== "function" ? ()=>bindings : bindings;
    if (name instanceof Element) return $f347e48613385d9c$var$applyBindingsObject(name, getBindings());
    else $f347e48613385d9c$var$binds[name] = getBindings;
    return ()=>{};
}
function $f347e48613385d9c$var$injectBindingProviders(obj) {
    Object.entries($f347e48613385d9c$var$binds).forEach(([name, callback])=>{
        Object.defineProperty(obj, name, {
            get () {
                return (...args)=>{
                    return callback(...args);
                };
            }
        });
    });
    return obj;
}
function $f347e48613385d9c$var$applyBindingsObject(el, obj, original) {
    let cleanupRunners = [];
    while(cleanupRunners.length)cleanupRunners.pop()();
    let attributes = Object.entries(obj).map(([name, value])=>({
            name: name,
            value: value
        }));
    let staticAttributes = $f347e48613385d9c$var$attributesOnly(attributes);
    attributes = attributes.map((attribute)=>{
        if (staticAttributes.find((attr)=>attr.name === attribute.name)) return {
            name: `x-bind:${attribute.name}`,
            value: `"${attribute.value}"`
        };
        return attribute;
    });
    $f347e48613385d9c$var$directives(el, attributes, original).map((handle)=>{
        cleanupRunners.push(handle.runCleanups);
        handle();
    });
    return ()=>{
        while(cleanupRunners.length)cleanupRunners.pop()();
    };
}
// packages/alpinejs/src/datas.js
var $f347e48613385d9c$var$datas = {};
function $f347e48613385d9c$var$data(name, callback) {
    $f347e48613385d9c$var$datas[name] = callback;
}
function $f347e48613385d9c$var$injectDataProviders(obj, context) {
    Object.entries($f347e48613385d9c$var$datas).forEach(([name, callback])=>{
        Object.defineProperty(obj, name, {
            get () {
                return (...args)=>{
                    return callback.bind(context)(...args);
                };
            },
            enumerable: false
        });
    });
    return obj;
}
// packages/alpinejs/src/alpine.js
var $f347e48613385d9c$var$Alpine = {
    get reactive () {
        return $f347e48613385d9c$var$reactive;
    },
    get release () {
        return $f347e48613385d9c$var$release;
    },
    get effect () {
        return $f347e48613385d9c$var$effect;
    },
    get raw () {
        return $f347e48613385d9c$var$raw;
    },
    version: "3.14.9",
    flushAndStopDeferringMutations: $f347e48613385d9c$var$flushAndStopDeferringMutations,
    dontAutoEvaluateFunctions: $f347e48613385d9c$var$dontAutoEvaluateFunctions,
    disableEffectScheduling: $f347e48613385d9c$var$disableEffectScheduling,
    startObservingMutations: $f347e48613385d9c$var$startObservingMutations,
    stopObservingMutations: $f347e48613385d9c$var$stopObservingMutations,
    setReactivityEngine: $f347e48613385d9c$var$setReactivityEngine,
    onAttributeRemoved: $f347e48613385d9c$var$onAttributeRemoved,
    onAttributesAdded: $f347e48613385d9c$var$onAttributesAdded,
    closestDataStack: $f347e48613385d9c$var$closestDataStack,
    skipDuringClone: $f347e48613385d9c$var$skipDuringClone,
    onlyDuringClone: $f347e48613385d9c$var$onlyDuringClone,
    addRootSelector: $f347e48613385d9c$var$addRootSelector,
    addInitSelector: $f347e48613385d9c$var$addInitSelector,
    interceptClone: $f347e48613385d9c$var$interceptClone,
    addScopeToNode: $f347e48613385d9c$var$addScopeToNode,
    deferMutations: $f347e48613385d9c$var$deferMutations,
    mapAttributes: $f347e48613385d9c$var$mapAttributes,
    evaluateLater: $f347e48613385d9c$var$evaluateLater,
    interceptInit: $f347e48613385d9c$var$interceptInit,
    setEvaluator: $f347e48613385d9c$var$setEvaluator,
    mergeProxies: $f347e48613385d9c$var$mergeProxies,
    extractProp: $f347e48613385d9c$var$extractProp,
    findClosest: $f347e48613385d9c$var$findClosest,
    onElRemoved: $f347e48613385d9c$var$onElRemoved,
    closestRoot: $f347e48613385d9c$var$closestRoot,
    destroyTree: $f347e48613385d9c$var$destroyTree,
    interceptor: $f347e48613385d9c$var$interceptor,
    transition: // INTERNAL: not public API and is subject to change without major release.
    $f347e48613385d9c$var$transition,
    setStyles: // INTERNAL
    $f347e48613385d9c$var$setStyles,
    mutateDom: // INTERNAL
    $f347e48613385d9c$var$mutateDom,
    directive: $f347e48613385d9c$var$directive,
    entangle: $f347e48613385d9c$var$entangle,
    throttle: $f347e48613385d9c$var$throttle,
    debounce: $f347e48613385d9c$var$debounce,
    evaluate: $f347e48613385d9c$var$evaluate,
    initTree: $f347e48613385d9c$var$initTree,
    nextTick: $f347e48613385d9c$var$nextTick,
    prefixed: $f347e48613385d9c$var$prefix,
    prefix: $f347e48613385d9c$var$setPrefix,
    plugin: $f347e48613385d9c$var$plugin,
    magic: $f347e48613385d9c$var$magic,
    store: $f347e48613385d9c$var$store,
    start: $f347e48613385d9c$var$start,
    clone: $f347e48613385d9c$var$clone,
    cloneNode: // INTERNAL
    $f347e48613385d9c$var$cloneNode,
    // INTERNAL
    bound: $f347e48613385d9c$var$getBinding,
    $data: $f347e48613385d9c$var$scope,
    watch: $f347e48613385d9c$var$watch,
    walk: $f347e48613385d9c$var$walk,
    data: $f347e48613385d9c$var$data,
    bind: $f347e48613385d9c$var$bind2
};
var $f347e48613385d9c$var$alpine_default = $f347e48613385d9c$var$Alpine;
// node_modules/@vue/shared/dist/shared.esm-bundler.js
function $f347e48613385d9c$var$makeMap(str, expectsLowerCase) {
    const map = /* @__PURE__ */ Object.create(null);
    const list = str.split(",");
    for(let i = 0; i < list.length; i++)map[list[i]] = true;
    return expectsLowerCase ? (val)=>!!map[val.toLowerCase()] : (val)=>!!map[val];
}
var $f347e48613385d9c$var$specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
var $f347e48613385d9c$var$isBooleanAttr2 = /* @__PURE__ */ $f347e48613385d9c$var$makeMap($f347e48613385d9c$var$specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,hidden,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected`);
var $f347e48613385d9c$var$EMPTY_OBJ = Object.freeze({});
var $f347e48613385d9c$var$EMPTY_ARR = Object.freeze([]);
var $f347e48613385d9c$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $f347e48613385d9c$var$hasOwn = (val, key)=>$f347e48613385d9c$var$hasOwnProperty.call(val, key);
var $f347e48613385d9c$var$isArray = Array.isArray;
var $f347e48613385d9c$var$isMap = (val)=>$f347e48613385d9c$var$toTypeString(val) === "[object Map]";
var $f347e48613385d9c$var$isString = (val)=>typeof val === "string";
var $f347e48613385d9c$var$isSymbol = (val)=>typeof val === "symbol";
var $f347e48613385d9c$var$isObject = (val)=>val !== null && typeof val === "object";
var $f347e48613385d9c$var$objectToString = Object.prototype.toString;
var $f347e48613385d9c$var$toTypeString = (value)=>$f347e48613385d9c$var$objectToString.call(value);
var $f347e48613385d9c$var$toRawType = (value)=>{
    return $f347e48613385d9c$var$toTypeString(value).slice(8, -1);
};
var $f347e48613385d9c$var$isIntegerKey = (key)=>$f347e48613385d9c$var$isString(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
var $f347e48613385d9c$var$cacheStringFunction = (fn)=>{
    const cache = /* @__PURE__ */ Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
var $f347e48613385d9c$var$camelizeRE = /-(\w)/g;
var $f347e48613385d9c$var$camelize = $f347e48613385d9c$var$cacheStringFunction((str)=>{
    return str.replace($f347e48613385d9c$var$camelizeRE, (_, c)=>c ? c.toUpperCase() : "");
});
var $f347e48613385d9c$var$hyphenateRE = /\B([A-Z])/g;
var $f347e48613385d9c$var$hyphenate = $f347e48613385d9c$var$cacheStringFunction((str)=>str.replace($f347e48613385d9c$var$hyphenateRE, "-$1").toLowerCase());
var $f347e48613385d9c$var$capitalize = $f347e48613385d9c$var$cacheStringFunction((str)=>str.charAt(0).toUpperCase() + str.slice(1));
var $f347e48613385d9c$var$toHandlerKey = $f347e48613385d9c$var$cacheStringFunction((str)=>str ? `on${$f347e48613385d9c$var$capitalize(str)}` : ``);
var $f347e48613385d9c$var$hasChanged = (value, oldValue)=>value !== oldValue && (value === value || oldValue === oldValue);
// node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js
var $f347e48613385d9c$var$targetMap = /* @__PURE__ */ new WeakMap();
var $f347e48613385d9c$var$effectStack = [];
var $f347e48613385d9c$var$activeEffect;
var $f347e48613385d9c$var$ITERATE_KEY = Symbol("iterate");
var $f347e48613385d9c$var$MAP_KEY_ITERATE_KEY = Symbol("Map key iterate");
function $f347e48613385d9c$var$isEffect(fn) {
    return fn && fn._isEffect === true;
}
function $f347e48613385d9c$var$effect2(fn, options = $f347e48613385d9c$var$EMPTY_OBJ) {
    if ($f347e48613385d9c$var$isEffect(fn)) fn = fn.raw;
    const effect3 = $f347e48613385d9c$var$createReactiveEffect(fn, options);
    if (!options.lazy) effect3();
    return effect3;
}
function $f347e48613385d9c$var$stop(effect3) {
    if (effect3.active) {
        $f347e48613385d9c$var$cleanup(effect3);
        if (effect3.options.onStop) effect3.options.onStop();
        effect3.active = false;
    }
}
var $f347e48613385d9c$var$uid = 0;
function $f347e48613385d9c$var$createReactiveEffect(fn, options) {
    const effect3 = function reactiveEffect() {
        if (!effect3.active) return fn();
        if (!$f347e48613385d9c$var$effectStack.includes(effect3)) {
            $f347e48613385d9c$var$cleanup(effect3);
            try {
                $f347e48613385d9c$var$enableTracking();
                $f347e48613385d9c$var$effectStack.push(effect3);
                $f347e48613385d9c$var$activeEffect = effect3;
                return fn();
            } finally{
                $f347e48613385d9c$var$effectStack.pop();
                $f347e48613385d9c$var$resetTracking();
                $f347e48613385d9c$var$activeEffect = $f347e48613385d9c$var$effectStack[$f347e48613385d9c$var$effectStack.length - 1];
            }
        }
    };
    effect3.id = $f347e48613385d9c$var$uid++;
    effect3.allowRecurse = !!options.allowRecurse;
    effect3._isEffect = true;
    effect3.active = true;
    effect3.raw = fn;
    effect3.deps = [];
    effect3.options = options;
    return effect3;
}
function $f347e48613385d9c$var$cleanup(effect3) {
    const { deps: deps } = effect3;
    if (deps.length) {
        for(let i = 0; i < deps.length; i++)deps[i].delete(effect3);
        deps.length = 0;
    }
}
var $f347e48613385d9c$var$shouldTrack = true;
var $f347e48613385d9c$var$trackStack = [];
function $f347e48613385d9c$var$pauseTracking() {
    $f347e48613385d9c$var$trackStack.push($f347e48613385d9c$var$shouldTrack);
    $f347e48613385d9c$var$shouldTrack = false;
}
function $f347e48613385d9c$var$enableTracking() {
    $f347e48613385d9c$var$trackStack.push($f347e48613385d9c$var$shouldTrack);
    $f347e48613385d9c$var$shouldTrack = true;
}
function $f347e48613385d9c$var$resetTracking() {
    const last = $f347e48613385d9c$var$trackStack.pop();
    $f347e48613385d9c$var$shouldTrack = last === void 0 ? true : last;
}
function $f347e48613385d9c$var$track(target, type, key) {
    if (!$f347e48613385d9c$var$shouldTrack || $f347e48613385d9c$var$activeEffect === void 0) return;
    let depsMap = $f347e48613385d9c$var$targetMap.get(target);
    if (!depsMap) $f347e48613385d9c$var$targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
    let dep = depsMap.get(key);
    if (!dep) depsMap.set(key, dep = /* @__PURE__ */ new Set());
    if (!dep.has($f347e48613385d9c$var$activeEffect)) {
        dep.add($f347e48613385d9c$var$activeEffect);
        $f347e48613385d9c$var$activeEffect.deps.push(dep);
        if ($f347e48613385d9c$var$activeEffect.options.onTrack) $f347e48613385d9c$var$activeEffect.options.onTrack({
            effect: $f347e48613385d9c$var$activeEffect,
            target: target,
            type: type,
            key: key
        });
    }
}
function $f347e48613385d9c$var$trigger(target, type, key, newValue, oldValue, oldTarget) {
    const depsMap = $f347e48613385d9c$var$targetMap.get(target);
    if (!depsMap) return;
    const effects = /* @__PURE__ */ new Set();
    const add2 = (effectsToAdd)=>{
        if (effectsToAdd) effectsToAdd.forEach((effect3)=>{
            if (effect3 !== $f347e48613385d9c$var$activeEffect || effect3.allowRecurse) effects.add(effect3);
        });
    };
    if (type === "clear") depsMap.forEach(add2);
    else if (key === "length" && $f347e48613385d9c$var$isArray(target)) depsMap.forEach((dep, key2)=>{
        if (key2 === "length" || key2 >= newValue) add2(dep);
    });
    else {
        if (key !== void 0) add2(depsMap.get(key));
        switch(type){
            case "add":
                if (!$f347e48613385d9c$var$isArray(target)) {
                    add2(depsMap.get($f347e48613385d9c$var$ITERATE_KEY));
                    if ($f347e48613385d9c$var$isMap(target)) add2(depsMap.get($f347e48613385d9c$var$MAP_KEY_ITERATE_KEY));
                } else if ($f347e48613385d9c$var$isIntegerKey(key)) add2(depsMap.get("length"));
                break;
            case "delete":
                if (!$f347e48613385d9c$var$isArray(target)) {
                    add2(depsMap.get($f347e48613385d9c$var$ITERATE_KEY));
                    if ($f347e48613385d9c$var$isMap(target)) add2(depsMap.get($f347e48613385d9c$var$MAP_KEY_ITERATE_KEY));
                }
                break;
            case "set":
                if ($f347e48613385d9c$var$isMap(target)) add2(depsMap.get($f347e48613385d9c$var$ITERATE_KEY));
                break;
        }
    }
    const run = (effect3)=>{
        if (effect3.options.onTrigger) effect3.options.onTrigger({
            effect: effect3,
            target: target,
            key: key,
            type: type,
            newValue: newValue,
            oldValue: oldValue,
            oldTarget: oldTarget
        });
        if (effect3.options.scheduler) effect3.options.scheduler(effect3);
        else effect3();
    };
    effects.forEach(run);
}
var $f347e48613385d9c$var$isNonTrackableKeys = /* @__PURE__ */ $f347e48613385d9c$var$makeMap(`__proto__,__v_isRef,__isVue`);
var $f347e48613385d9c$var$builtInSymbols = new Set(Object.getOwnPropertyNames(Symbol).map((key)=>Symbol[key]).filter($f347e48613385d9c$var$isSymbol));
var $f347e48613385d9c$var$get2 = /* @__PURE__ */ $f347e48613385d9c$var$createGetter();
var $f347e48613385d9c$var$readonlyGet = /* @__PURE__ */ $f347e48613385d9c$var$createGetter(true);
var $f347e48613385d9c$var$arrayInstrumentations = /* @__PURE__ */ $f347e48613385d9c$var$createArrayInstrumentations();
function $f347e48613385d9c$var$createArrayInstrumentations() {
    const instrumentations = {};
    [
        "includes",
        "indexOf",
        "lastIndexOf"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            const arr = $f347e48613385d9c$var$toRaw(this);
            for(let i = 0, l = this.length; i < l; i++)$f347e48613385d9c$var$track(arr, "get", i + "");
            const res = arr[key](...args);
            if (res === -1 || res === false) return arr[key](...args.map($f347e48613385d9c$var$toRaw));
            else return res;
        };
    });
    [
        "push",
        "pop",
        "shift",
        "unshift",
        "splice"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            $f347e48613385d9c$var$pauseTracking();
            const res = $f347e48613385d9c$var$toRaw(this)[key].apply(this, args);
            $f347e48613385d9c$var$resetTracking();
            return res;
        };
    });
    return instrumentations;
}
function $f347e48613385d9c$var$createGetter(isReadonly = false, shallow = false) {
    return function get3(target, key, receiver) {
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw" && receiver === (isReadonly ? shallow ? $f347e48613385d9c$var$shallowReadonlyMap : $f347e48613385d9c$var$readonlyMap : shallow ? $f347e48613385d9c$var$shallowReactiveMap : $f347e48613385d9c$var$reactiveMap).get(target)) return target;
        const targetIsArray = $f347e48613385d9c$var$isArray(target);
        if (!isReadonly && targetIsArray && $f347e48613385d9c$var$hasOwn($f347e48613385d9c$var$arrayInstrumentations, key)) return Reflect.get($f347e48613385d9c$var$arrayInstrumentations, key, receiver);
        const res = Reflect.get(target, key, receiver);
        if ($f347e48613385d9c$var$isSymbol(key) ? $f347e48613385d9c$var$builtInSymbols.has(key) : $f347e48613385d9c$var$isNonTrackableKeys(key)) return res;
        if (!isReadonly) $f347e48613385d9c$var$track(target, "get", key);
        if (shallow) return res;
        if ($f347e48613385d9c$var$isRef(res)) {
            const shouldUnwrap = !targetIsArray || !$f347e48613385d9c$var$isIntegerKey(key);
            return shouldUnwrap ? res.value : res;
        }
        if ($f347e48613385d9c$var$isObject(res)) return isReadonly ? $f347e48613385d9c$var$readonly(res) : $f347e48613385d9c$var$reactive2(res);
        return res;
    };
}
var $f347e48613385d9c$var$set2 = /* @__PURE__ */ $f347e48613385d9c$var$createSetter();
function $f347e48613385d9c$var$createSetter(shallow = false) {
    return function set3(target, key, value, receiver) {
        let oldValue = target[key];
        if (!shallow) {
            value = $f347e48613385d9c$var$toRaw(value);
            oldValue = $f347e48613385d9c$var$toRaw(oldValue);
            if (!$f347e48613385d9c$var$isArray(target) && $f347e48613385d9c$var$isRef(oldValue) && !$f347e48613385d9c$var$isRef(value)) {
                oldValue.value = value;
                return true;
            }
        }
        const hadKey = $f347e48613385d9c$var$isArray(target) && $f347e48613385d9c$var$isIntegerKey(key) ? Number(key) < target.length : $f347e48613385d9c$var$hasOwn(target, key);
        const result = Reflect.set(target, key, value, receiver);
        if (target === $f347e48613385d9c$var$toRaw(receiver)) {
            if (!hadKey) $f347e48613385d9c$var$trigger(target, "add", key, value);
            else if ($f347e48613385d9c$var$hasChanged(value, oldValue)) $f347e48613385d9c$var$trigger(target, "set", key, value, oldValue);
        }
        return result;
    };
}
function $f347e48613385d9c$var$deleteProperty(target, key) {
    const hadKey = $f347e48613385d9c$var$hasOwn(target, key);
    const oldValue = target[key];
    const result = Reflect.deleteProperty(target, key);
    if (result && hadKey) $f347e48613385d9c$var$trigger(target, "delete", key, void 0, oldValue);
    return result;
}
function $f347e48613385d9c$var$has(target, key) {
    const result = Reflect.has(target, key);
    if (!$f347e48613385d9c$var$isSymbol(key) || !$f347e48613385d9c$var$builtInSymbols.has(key)) $f347e48613385d9c$var$track(target, "has", key);
    return result;
}
function $f347e48613385d9c$var$ownKeys(target) {
    $f347e48613385d9c$var$track(target, "iterate", $f347e48613385d9c$var$isArray(target) ? "length" : $f347e48613385d9c$var$ITERATE_KEY);
    return Reflect.ownKeys(target);
}
var $f347e48613385d9c$var$mutableHandlers = {
    get: $f347e48613385d9c$var$get2,
    set: $f347e48613385d9c$var$set2,
    deleteProperty: $f347e48613385d9c$var$deleteProperty,
    has: $f347e48613385d9c$var$has,
    ownKeys: $f347e48613385d9c$var$ownKeys
};
var $f347e48613385d9c$var$readonlyHandlers = {
    get: $f347e48613385d9c$var$readonlyGet,
    set (target, key) {
        console.warn(`Set operation on key "${String(key)}" failed: target is readonly.`, target);
        return true;
    },
    deleteProperty (target, key) {
        console.warn(`Delete operation on key "${String(key)}" failed: target is readonly.`, target);
        return true;
    }
};
var $f347e48613385d9c$var$toReactive = (value)=>$f347e48613385d9c$var$isObject(value) ? $f347e48613385d9c$var$reactive2(value) : value;
var $f347e48613385d9c$var$toReadonly = (value)=>$f347e48613385d9c$var$isObject(value) ? $f347e48613385d9c$var$readonly(value) : value;
var $f347e48613385d9c$var$toShallow = (value)=>value;
var $f347e48613385d9c$var$getProto = (v)=>Reflect.getPrototypeOf(v);
function $f347e48613385d9c$var$get$1(target, key, isReadonly = false, isShallow = false) {
    target = target["__v_raw"];
    const rawTarget = $f347e48613385d9c$var$toRaw(target);
    const rawKey = $f347e48613385d9c$var$toRaw(key);
    if (key !== rawKey) !isReadonly && $f347e48613385d9c$var$track(rawTarget, "get", key);
    !isReadonly && $f347e48613385d9c$var$track(rawTarget, "get", rawKey);
    const { has: has2 } = $f347e48613385d9c$var$getProto(rawTarget);
    const wrap = isShallow ? $f347e48613385d9c$var$toShallow : isReadonly ? $f347e48613385d9c$var$toReadonly : $f347e48613385d9c$var$toReactive;
    if (has2.call(rawTarget, key)) return wrap(target.get(key));
    else if (has2.call(rawTarget, rawKey)) return wrap(target.get(rawKey));
    else if (target !== rawTarget) target.get(key);
}
function $f347e48613385d9c$var$has$1(key, isReadonly = false) {
    const target = this["__v_raw"];
    const rawTarget = $f347e48613385d9c$var$toRaw(target);
    const rawKey = $f347e48613385d9c$var$toRaw(key);
    if (key !== rawKey) !isReadonly && $f347e48613385d9c$var$track(rawTarget, "has", key);
    !isReadonly && $f347e48613385d9c$var$track(rawTarget, "has", rawKey);
    return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
}
function $f347e48613385d9c$var$size(target, isReadonly = false) {
    target = target["__v_raw"];
    !isReadonly && $f347e48613385d9c$var$track($f347e48613385d9c$var$toRaw(target), "iterate", $f347e48613385d9c$var$ITERATE_KEY);
    return Reflect.get(target, "size", target);
}
function $f347e48613385d9c$var$add(value) {
    value = $f347e48613385d9c$var$toRaw(value);
    const target = $f347e48613385d9c$var$toRaw(this);
    const proto = $f347e48613385d9c$var$getProto(target);
    const hadKey = proto.has.call(target, value);
    if (!hadKey) {
        target.add(value);
        $f347e48613385d9c$var$trigger(target, "add", value, value);
    }
    return this;
}
function $f347e48613385d9c$var$set$1(key, value) {
    value = $f347e48613385d9c$var$toRaw(value);
    const target = $f347e48613385d9c$var$toRaw(this);
    const { has: has2, get: get3 } = $f347e48613385d9c$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $f347e48613385d9c$var$toRaw(key);
        hadKey = has2.call(target, key);
    } else $f347e48613385d9c$var$checkIdentityKeys(target, has2, key);
    const oldValue = get3.call(target, key);
    target.set(key, value);
    if (!hadKey) $f347e48613385d9c$var$trigger(target, "add", key, value);
    else if ($f347e48613385d9c$var$hasChanged(value, oldValue)) $f347e48613385d9c$var$trigger(target, "set", key, value, oldValue);
    return this;
}
function $f347e48613385d9c$var$deleteEntry(key) {
    const target = $f347e48613385d9c$var$toRaw(this);
    const { has: has2, get: get3 } = $f347e48613385d9c$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $f347e48613385d9c$var$toRaw(key);
        hadKey = has2.call(target, key);
    } else $f347e48613385d9c$var$checkIdentityKeys(target, has2, key);
    const oldValue = get3 ? get3.call(target, key) : void 0;
    const result = target.delete(key);
    if (hadKey) $f347e48613385d9c$var$trigger(target, "delete", key, void 0, oldValue);
    return result;
}
function $f347e48613385d9c$var$clear() {
    const target = $f347e48613385d9c$var$toRaw(this);
    const hadItems = target.size !== 0;
    const oldTarget = $f347e48613385d9c$var$isMap(target) ? new Map(target) : new Set(target);
    const result = target.clear();
    if (hadItems) $f347e48613385d9c$var$trigger(target, "clear", void 0, void 0, oldTarget);
    return result;
}
function $f347e48613385d9c$var$createForEach(isReadonly, isShallow) {
    return function forEach(callback, thisArg) {
        const observed = this;
        const target = observed["__v_raw"];
        const rawTarget = $f347e48613385d9c$var$toRaw(target);
        const wrap = isShallow ? $f347e48613385d9c$var$toShallow : isReadonly ? $f347e48613385d9c$var$toReadonly : $f347e48613385d9c$var$toReactive;
        !isReadonly && $f347e48613385d9c$var$track(rawTarget, "iterate", $f347e48613385d9c$var$ITERATE_KEY);
        return target.forEach((value, key)=>{
            return callback.call(thisArg, wrap(value), wrap(key), observed);
        });
    };
}
function $f347e48613385d9c$var$createIterableMethod(method, isReadonly, isShallow) {
    return function(...args) {
        const target = this["__v_raw"];
        const rawTarget = $f347e48613385d9c$var$toRaw(target);
        const targetIsMap = $f347e48613385d9c$var$isMap(rawTarget);
        const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
        const isKeyOnly = method === "keys" && targetIsMap;
        const innerIterator = target[method](...args);
        const wrap = isShallow ? $f347e48613385d9c$var$toShallow : isReadonly ? $f347e48613385d9c$var$toReadonly : $f347e48613385d9c$var$toReactive;
        !isReadonly && $f347e48613385d9c$var$track(rawTarget, "iterate", isKeyOnly ? $f347e48613385d9c$var$MAP_KEY_ITERATE_KEY : $f347e48613385d9c$var$ITERATE_KEY);
        return {
            // iterator protocol
            next () {
                const { value: value, done: done } = innerIterator.next();
                return done ? {
                    value: value,
                    done: done
                } : {
                    value: isPair ? [
                        wrap(value[0]),
                        wrap(value[1])
                    ] : wrap(value),
                    done: done
                };
            },
            // iterable protocol
            [Symbol.iterator] () {
                return this;
            }
        };
    };
}
function $f347e48613385d9c$var$createReadonlyMethod(type) {
    return function(...args) {
        {
            const key = args[0] ? `on key "${args[0]}" ` : ``;
            console.warn(`${$f347e48613385d9c$var$capitalize(type)} operation ${key}failed: target is readonly.`, $f347e48613385d9c$var$toRaw(this));
        }
        return type === "delete" ? false : this;
    };
}
function $f347e48613385d9c$var$createInstrumentations() {
    const mutableInstrumentations2 = {
        get (key) {
            return $f347e48613385d9c$var$get$1(this, key);
        },
        get size () {
            return $f347e48613385d9c$var$size(this);
        },
        has: $f347e48613385d9c$var$has$1,
        add: $f347e48613385d9c$var$add,
        set: $f347e48613385d9c$var$set$1,
        delete: $f347e48613385d9c$var$deleteEntry,
        clear: $f347e48613385d9c$var$clear,
        forEach: $f347e48613385d9c$var$createForEach(false, false)
    };
    const shallowInstrumentations2 = {
        get (key) {
            return $f347e48613385d9c$var$get$1(this, key, false, true);
        },
        get size () {
            return $f347e48613385d9c$var$size(this);
        },
        has: $f347e48613385d9c$var$has$1,
        add: $f347e48613385d9c$var$add,
        set: $f347e48613385d9c$var$set$1,
        delete: $f347e48613385d9c$var$deleteEntry,
        clear: $f347e48613385d9c$var$clear,
        forEach: $f347e48613385d9c$var$createForEach(false, true)
    };
    const readonlyInstrumentations2 = {
        get (key) {
            return $f347e48613385d9c$var$get$1(this, key, true);
        },
        get size () {
            return $f347e48613385d9c$var$size(this, true);
        },
        has (key) {
            return $f347e48613385d9c$var$has$1.call(this, key, true);
        },
        add: $f347e48613385d9c$var$createReadonlyMethod("add"),
        set: $f347e48613385d9c$var$createReadonlyMethod("set"),
        delete: $f347e48613385d9c$var$createReadonlyMethod("delete"),
        clear: $f347e48613385d9c$var$createReadonlyMethod("clear"),
        forEach: $f347e48613385d9c$var$createForEach(true, false)
    };
    const shallowReadonlyInstrumentations2 = {
        get (key) {
            return $f347e48613385d9c$var$get$1(this, key, true, true);
        },
        get size () {
            return $f347e48613385d9c$var$size(this, true);
        },
        has (key) {
            return $f347e48613385d9c$var$has$1.call(this, key, true);
        },
        add: $f347e48613385d9c$var$createReadonlyMethod("add"),
        set: $f347e48613385d9c$var$createReadonlyMethod("set"),
        delete: $f347e48613385d9c$var$createReadonlyMethod("delete"),
        clear: $f347e48613385d9c$var$createReadonlyMethod("clear"),
        forEach: $f347e48613385d9c$var$createForEach(true, true)
    };
    const iteratorMethods = [
        "keys",
        "values",
        "entries",
        Symbol.iterator
    ];
    iteratorMethods.forEach((method)=>{
        mutableInstrumentations2[method] = $f347e48613385d9c$var$createIterableMethod(method, false, false);
        readonlyInstrumentations2[method] = $f347e48613385d9c$var$createIterableMethod(method, true, false);
        shallowInstrumentations2[method] = $f347e48613385d9c$var$createIterableMethod(method, false, true);
        shallowReadonlyInstrumentations2[method] = $f347e48613385d9c$var$createIterableMethod(method, true, true);
    });
    return [
        mutableInstrumentations2,
        readonlyInstrumentations2,
        shallowInstrumentations2,
        shallowReadonlyInstrumentations2
    ];
}
var [$f347e48613385d9c$var$mutableInstrumentations, $f347e48613385d9c$var$readonlyInstrumentations, $f347e48613385d9c$var$shallowInstrumentations, $f347e48613385d9c$var$shallowReadonlyInstrumentations] = /* @__PURE__ */ $f347e48613385d9c$var$createInstrumentations();
function $f347e48613385d9c$var$createInstrumentationGetter(isReadonly, shallow) {
    const instrumentations = shallow ? isReadonly ? $f347e48613385d9c$var$shallowReadonlyInstrumentations : $f347e48613385d9c$var$shallowInstrumentations : isReadonly ? $f347e48613385d9c$var$readonlyInstrumentations : $f347e48613385d9c$var$mutableInstrumentations;
    return (target, key, receiver)=>{
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw") return target;
        return Reflect.get($f347e48613385d9c$var$hasOwn(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
}
var $f347e48613385d9c$var$mutableCollectionHandlers = {
    get: /* @__PURE__ */ $f347e48613385d9c$var$createInstrumentationGetter(false, false)
};
var $f347e48613385d9c$var$readonlyCollectionHandlers = {
    get: /* @__PURE__ */ $f347e48613385d9c$var$createInstrumentationGetter(true, false)
};
function $f347e48613385d9c$var$checkIdentityKeys(target, has2, key) {
    const rawKey = $f347e48613385d9c$var$toRaw(key);
    if (rawKey !== key && has2.call(target, rawKey)) {
        const type = $f347e48613385d9c$var$toRawType(target);
        console.warn(`Reactive ${type} contains both the raw and reactive versions of the same object${type === `Map` ? ` as keys` : ``}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
    }
}
var $f347e48613385d9c$var$reactiveMap = /* @__PURE__ */ new WeakMap();
var $f347e48613385d9c$var$shallowReactiveMap = /* @__PURE__ */ new WeakMap();
var $f347e48613385d9c$var$readonlyMap = /* @__PURE__ */ new WeakMap();
var $f347e48613385d9c$var$shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function $f347e48613385d9c$var$targetTypeMap(rawType) {
    switch(rawType){
        case "Object":
        case "Array":
            return 1;
        case "Map":
        case "Set":
        case "WeakMap":
        case "WeakSet":
            return 2;
        default:
            return 0;
    }
}
function $f347e48613385d9c$var$getTargetType(value) {
    return value["__v_skip"] || !Object.isExtensible(value) ? 0 : $f347e48613385d9c$var$targetTypeMap($f347e48613385d9c$var$toRawType(value));
}
function $f347e48613385d9c$var$reactive2(target) {
    if (target && target["__v_isReadonly"]) return target;
    return $f347e48613385d9c$var$createReactiveObject(target, false, $f347e48613385d9c$var$mutableHandlers, $f347e48613385d9c$var$mutableCollectionHandlers, $f347e48613385d9c$var$reactiveMap);
}
function $f347e48613385d9c$var$readonly(target) {
    return $f347e48613385d9c$var$createReactiveObject(target, true, $f347e48613385d9c$var$readonlyHandlers, $f347e48613385d9c$var$readonlyCollectionHandlers, $f347e48613385d9c$var$readonlyMap);
}
function $f347e48613385d9c$var$createReactiveObject(target, isReadonly, baseHandlers, collectionHandlers, proxyMap) {
    if (!$f347e48613385d9c$var$isObject(target)) {
        console.warn(`value cannot be made reactive: ${String(target)}`);
        return target;
    }
    if (target["__v_raw"] && !(isReadonly && target["__v_isReactive"])) return target;
    const existingProxy = proxyMap.get(target);
    if (existingProxy) return existingProxy;
    const targetType = $f347e48613385d9c$var$getTargetType(target);
    if (targetType === 0) return target;
    const proxy = new Proxy(target, targetType === 2 ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
}
function $f347e48613385d9c$var$toRaw(observed) {
    return observed && $f347e48613385d9c$var$toRaw(observed["__v_raw"]) || observed;
}
function $f347e48613385d9c$var$isRef(r) {
    return Boolean(r && r.__v_isRef === true);
}
// packages/alpinejs/src/magics/$nextTick.js
$f347e48613385d9c$var$magic("nextTick", ()=>$f347e48613385d9c$var$nextTick);
// packages/alpinejs/src/magics/$dispatch.js
$f347e48613385d9c$var$magic("dispatch", (el)=>$f347e48613385d9c$var$dispatch.bind($f347e48613385d9c$var$dispatch, el));
// packages/alpinejs/src/magics/$watch.js
$f347e48613385d9c$var$magic("watch", (el, { evaluateLater: evaluateLater2, cleanup: cleanup2 })=>(key, callback)=>{
        let evaluate2 = evaluateLater2(key);
        let getter = ()=>{
            let value;
            evaluate2((i)=>value = i);
            return value;
        };
        let unwatch = $f347e48613385d9c$var$watch(getter, callback);
        cleanup2(unwatch);
    });
// packages/alpinejs/src/magics/$store.js
$f347e48613385d9c$var$magic("store", $f347e48613385d9c$var$getStores);
// packages/alpinejs/src/magics/$data.js
$f347e48613385d9c$var$magic("data", (el)=>$f347e48613385d9c$var$scope(el));
// packages/alpinejs/src/magics/$root.js
$f347e48613385d9c$var$magic("root", (el)=>$f347e48613385d9c$var$closestRoot(el));
// packages/alpinejs/src/magics/$refs.js
$f347e48613385d9c$var$magic("refs", (el)=>{
    if (el._x_refs_proxy) return el._x_refs_proxy;
    el._x_refs_proxy = $f347e48613385d9c$var$mergeProxies($f347e48613385d9c$var$getArrayOfRefObject(el));
    return el._x_refs_proxy;
});
function $f347e48613385d9c$var$getArrayOfRefObject(el) {
    let refObjects = [];
    $f347e48613385d9c$var$findClosest(el, (i)=>{
        if (i._x_refs) refObjects.push(i._x_refs);
    });
    return refObjects;
}
// packages/alpinejs/src/ids.js
var $f347e48613385d9c$var$globalIdMemo = {};
function $f347e48613385d9c$var$findAndIncrementId(name) {
    if (!$f347e48613385d9c$var$globalIdMemo[name]) $f347e48613385d9c$var$globalIdMemo[name] = 0;
    return ++$f347e48613385d9c$var$globalIdMemo[name];
}
function $f347e48613385d9c$var$closestIdRoot(el, name) {
    return $f347e48613385d9c$var$findClosest(el, (element)=>{
        if (element._x_ids && element._x_ids[name]) return true;
    });
}
function $f347e48613385d9c$var$setIdRoot(el, name) {
    if (!el._x_ids) el._x_ids = {};
    if (!el._x_ids[name]) el._x_ids[name] = $f347e48613385d9c$var$findAndIncrementId(name);
}
// packages/alpinejs/src/magics/$id.js
$f347e48613385d9c$var$magic("id", (el, { cleanup: cleanup2 })=>(name, key = null)=>{
        let cacheKey = `${name}${key ? `-${key}` : ""}`;
        return $f347e48613385d9c$var$cacheIdByNameOnElement(el, cacheKey, cleanup2, ()=>{
            let root = $f347e48613385d9c$var$closestIdRoot(el, name);
            let id = root ? root._x_ids[name] : $f347e48613385d9c$var$findAndIncrementId(name);
            return key ? `${name}-${id}-${key}` : `${name}-${id}`;
        });
    });
$f347e48613385d9c$var$interceptClone((from, to)=>{
    if (from._x_id) to._x_id = from._x_id;
});
function $f347e48613385d9c$var$cacheIdByNameOnElement(el, cacheKey, cleanup2, callback) {
    if (!el._x_id) el._x_id = {};
    if (el._x_id[cacheKey]) return el._x_id[cacheKey];
    let output = callback();
    el._x_id[cacheKey] = output;
    cleanup2(()=>{
        delete el._x_id[cacheKey];
    });
    return output;
}
// packages/alpinejs/src/magics/$el.js
$f347e48613385d9c$var$magic("el", (el)=>el);
// packages/alpinejs/src/magics/index.js
$f347e48613385d9c$var$warnMissingPluginMagic("Focus", "focus", "focus");
$f347e48613385d9c$var$warnMissingPluginMagic("Persist", "persist", "persist");
function $f347e48613385d9c$var$warnMissingPluginMagic(name, magicName, slug) {
    $f347e48613385d9c$var$magic(magicName, (el)=>$f347e48613385d9c$var$warn(`You can't use [$${magicName}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
}
// packages/alpinejs/src/directives/x-modelable.js
$f347e48613385d9c$var$directive("modelable", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2, cleanup: cleanup2 })=>{
    let func = evaluateLater2(expression);
    let innerGet = ()=>{
        let result;
        func((i)=>result = i);
        return result;
    };
    let evaluateInnerSet = evaluateLater2(`${expression} = __placeholder`);
    let innerSet = (val)=>evaluateInnerSet(()=>{}, {
            scope: {
                "__placeholder": val
            }
        });
    let initialValue = innerGet();
    innerSet(initialValue);
    queueMicrotask(()=>{
        if (!el._x_model) return;
        el._x_removeModelListeners["default"]();
        let outerGet = el._x_model.get;
        let outerSet = el._x_model.set;
        let releaseEntanglement = $f347e48613385d9c$var$entangle({
            get () {
                return outerGet();
            },
            set (value) {
                outerSet(value);
            }
        }, {
            get () {
                return innerGet();
            },
            set (value) {
                innerSet(value);
            }
        });
        cleanup2(releaseEntanglement);
    });
});
// packages/alpinejs/src/directives/x-teleport.js
$f347e48613385d9c$var$directive("teleport", (el, { modifiers: modifiers, expression: expression }, { cleanup: cleanup2 })=>{
    if (el.tagName.toLowerCase() !== "template") $f347e48613385d9c$var$warn("x-teleport can only be used on a <template> tag", el);
    let target = $f347e48613385d9c$var$getTarget(expression);
    let clone2 = el.content.cloneNode(true).firstElementChild;
    el._x_teleport = clone2;
    clone2._x_teleportBack = el;
    el.setAttribute("data-teleport-template", true);
    clone2.setAttribute("data-teleport-target", true);
    if (el._x_forwardEvents) el._x_forwardEvents.forEach((eventName)=>{
        clone2.addEventListener(eventName, (e)=>{
            e.stopPropagation();
            el.dispatchEvent(new e.constructor(e.type, e));
        });
    });
    $f347e48613385d9c$var$addScopeToNode(clone2, {}, el);
    let placeInDom = (clone3, target2, modifiers2)=>{
        if (modifiers2.includes("prepend")) target2.parentNode.insertBefore(clone3, target2);
        else if (modifiers2.includes("append")) target2.parentNode.insertBefore(clone3, target2.nextSibling);
        else target2.appendChild(clone3);
    };
    $f347e48613385d9c$var$mutateDom(()=>{
        placeInDom(clone2, target, modifiers);
        $f347e48613385d9c$var$skipDuringClone(()=>{
            $f347e48613385d9c$var$initTree(clone2);
        })();
    });
    el._x_teleportPutBack = ()=>{
        let target2 = $f347e48613385d9c$var$getTarget(expression);
        $f347e48613385d9c$var$mutateDom(()=>{
            placeInDom(el._x_teleport, target2, modifiers);
        });
    };
    cleanup2(()=>$f347e48613385d9c$var$mutateDom(()=>{
            clone2.remove();
            $f347e48613385d9c$var$destroyTree(clone2);
        }));
});
var $f347e48613385d9c$var$teleportContainerDuringClone = document.createElement("div");
function $f347e48613385d9c$var$getTarget(expression) {
    let target = $f347e48613385d9c$var$skipDuringClone(()=>{
        return document.querySelector(expression);
    }, ()=>{
        return $f347e48613385d9c$var$teleportContainerDuringClone;
    })();
    if (!target) $f347e48613385d9c$var$warn(`Cannot find x-teleport element for selector: "${expression}"`);
    return target;
}
// packages/alpinejs/src/directives/x-ignore.js
var $f347e48613385d9c$var$handler = ()=>{};
$f347e48613385d9c$var$handler.inline = (el, { modifiers: modifiers }, { cleanup: cleanup2 })=>{
    modifiers.includes("self") ? el._x_ignoreSelf = true : el._x_ignore = true;
    cleanup2(()=>{
        modifiers.includes("self") ? delete el._x_ignoreSelf : delete el._x_ignore;
    });
};
$f347e48613385d9c$var$directive("ignore", $f347e48613385d9c$var$handler);
// packages/alpinejs/src/directives/x-effect.js
$f347e48613385d9c$var$directive("effect", $f347e48613385d9c$var$skipDuringClone((el, { expression: expression }, { effect: effect3 })=>{
    effect3($f347e48613385d9c$var$evaluateLater(el, expression));
}));
// packages/alpinejs/src/utils/on.js
function $f347e48613385d9c$var$on(el, event, modifiers, callback) {
    let listenerTarget = el;
    let handler4 = (e)=>callback(e);
    let options = {};
    let wrapHandler = (callback2, wrapper)=>(e)=>wrapper(callback2, e);
    if (modifiers.includes("dot")) event = $f347e48613385d9c$var$dotSyntax(event);
    if (modifiers.includes("camel")) event = $f347e48613385d9c$var$camelCase2(event);
    if (modifiers.includes("passive")) options.passive = true;
    if (modifiers.includes("capture")) options.capture = true;
    if (modifiers.includes("window")) listenerTarget = window;
    if (modifiers.includes("document")) listenerTarget = document;
    if (modifiers.includes("debounce")) {
        let nextModifier = modifiers[modifiers.indexOf("debounce") + 1] || "invalid-wait";
        let wait = $f347e48613385d9c$var$isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
        handler4 = $f347e48613385d9c$var$debounce(handler4, wait);
    }
    if (modifiers.includes("throttle")) {
        let nextModifier = modifiers[modifiers.indexOf("throttle") + 1] || "invalid-wait";
        let wait = $f347e48613385d9c$var$isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
        handler4 = $f347e48613385d9c$var$throttle(handler4, wait);
    }
    if (modifiers.includes("prevent")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.preventDefault();
        next(e);
    });
    if (modifiers.includes("stop")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.stopPropagation();
        next(e);
    });
    if (modifiers.includes("once")) handler4 = wrapHandler(handler4, (next, e)=>{
        next(e);
        listenerTarget.removeEventListener(event, handler4, options);
    });
    if (modifiers.includes("away") || modifiers.includes("outside")) {
        listenerTarget = document;
        handler4 = wrapHandler(handler4, (next, e)=>{
            if (el.contains(e.target)) return;
            if (e.target.isConnected === false) return;
            if (el.offsetWidth < 1 && el.offsetHeight < 1) return;
            if (el._x_isShown === false) return;
            next(e);
        });
    }
    if (modifiers.includes("self")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.target === el && next(e);
    });
    if ($f347e48613385d9c$var$isKeyEvent(event) || $f347e48613385d9c$var$isClickEvent(event)) handler4 = wrapHandler(handler4, (next, e)=>{
        if ($f347e48613385d9c$var$isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers)) return;
        next(e);
    });
    listenerTarget.addEventListener(event, handler4, options);
    return ()=>{
        listenerTarget.removeEventListener(event, handler4, options);
    };
}
function $f347e48613385d9c$var$dotSyntax(subject) {
    return subject.replace(/-/g, ".");
}
function $f347e48613385d9c$var$camelCase2(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, (match, char)=>char.toUpperCase());
}
function $f347e48613385d9c$var$isNumeric(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
function $f347e48613385d9c$var$kebabCase2(subject) {
    if ([
        " ",
        "_"
    ].includes(subject)) return subject;
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[_\s]/, "-").toLowerCase();
}
function $f347e48613385d9c$var$isKeyEvent(event) {
    return [
        "keydown",
        "keyup"
    ].includes(event);
}
function $f347e48613385d9c$var$isClickEvent(event) {
    return [
        "contextmenu",
        "click",
        "mouse"
    ].some((i)=>event.includes(i));
}
function $f347e48613385d9c$var$isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers) {
    let keyModifiers = modifiers.filter((i)=>{
        return ![
            "window",
            "document",
            "prevent",
            "stop",
            "once",
            "capture",
            "self",
            "away",
            "outside",
            "passive"
        ].includes(i);
    });
    if (keyModifiers.includes("debounce")) {
        let debounceIndex = keyModifiers.indexOf("debounce");
        keyModifiers.splice(debounceIndex, $f347e48613385d9c$var$isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.includes("throttle")) {
        let debounceIndex = keyModifiers.indexOf("throttle");
        keyModifiers.splice(debounceIndex, $f347e48613385d9c$var$isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.length === 0) return false;
    if (keyModifiers.length === 1 && $f347e48613385d9c$var$keyToModifiers(e.key).includes(keyModifiers[0])) return false;
    const systemKeyModifiers = [
        "ctrl",
        "shift",
        "alt",
        "meta",
        "cmd",
        "super"
    ];
    const selectedSystemKeyModifiers = systemKeyModifiers.filter((modifier)=>keyModifiers.includes(modifier));
    keyModifiers = keyModifiers.filter((i)=>!selectedSystemKeyModifiers.includes(i));
    if (selectedSystemKeyModifiers.length > 0) {
        const activelyPressedKeyModifiers = selectedSystemKeyModifiers.filter((modifier)=>{
            if (modifier === "cmd" || modifier === "super") modifier = "meta";
            return e[`${modifier}Key`];
        });
        if (activelyPressedKeyModifiers.length === selectedSystemKeyModifiers.length) {
            if ($f347e48613385d9c$var$isClickEvent(e.type)) return false;
            if ($f347e48613385d9c$var$keyToModifiers(e.key).includes(keyModifiers[0])) return false;
        }
    }
    return true;
}
function $f347e48613385d9c$var$keyToModifiers(key) {
    if (!key) return [];
    key = $f347e48613385d9c$var$kebabCase2(key);
    let modifierToKeyMap = {
        "ctrl": "control",
        "slash": "/",
        "space": " ",
        "spacebar": " ",
        "cmd": "meta",
        "esc": "escape",
        "up": "arrow-up",
        "down": "arrow-down",
        "left": "arrow-left",
        "right": "arrow-right",
        "period": ".",
        "comma": ",",
        "equal": "=",
        "minus": "-",
        "underscore": "_"
    };
    modifierToKeyMap[key] = key;
    return Object.keys(modifierToKeyMap).map((modifier)=>{
        if (modifierToKeyMap[modifier] === key) return modifier;
    }).filter((modifier)=>modifier);
}
// packages/alpinejs/src/directives/x-model.js
$f347e48613385d9c$var$directive("model", (el, { modifiers: modifiers, expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    let scopeTarget = el;
    if (modifiers.includes("parent")) scopeTarget = el.parentNode;
    let evaluateGet = $f347e48613385d9c$var$evaluateLater(scopeTarget, expression);
    let evaluateSet;
    if (typeof expression === "string") evaluateSet = $f347e48613385d9c$var$evaluateLater(scopeTarget, `${expression} = __placeholder`);
    else if (typeof expression === "function" && typeof expression() === "string") evaluateSet = $f347e48613385d9c$var$evaluateLater(scopeTarget, `${expression()} = __placeholder`);
    else evaluateSet = ()=>{};
    let getValue = ()=>{
        let result;
        evaluateGet((value)=>result = value);
        return $f347e48613385d9c$var$isGetterSetter(result) ? result.get() : result;
    };
    let setValue = (value)=>{
        let result;
        evaluateGet((value2)=>result = value2);
        if ($f347e48613385d9c$var$isGetterSetter(result)) result.set(value);
        else evaluateSet(()=>{}, {
            scope: {
                "__placeholder": value
            }
        });
    };
    if (typeof expression === "string" && el.type === "radio") $f347e48613385d9c$var$mutateDom(()=>{
        if (!el.hasAttribute("name")) el.setAttribute("name", expression);
    });
    var event = el.tagName.toLowerCase() === "select" || [
        "checkbox",
        "radio"
    ].includes(el.type) || modifiers.includes("lazy") ? "change" : "input";
    let removeListener = $f347e48613385d9c$var$isCloning ? ()=>{} : $f347e48613385d9c$var$on(el, event, modifiers, (e)=>{
        setValue($f347e48613385d9c$var$getInputValue(el, modifiers, e, getValue()));
    });
    if (modifiers.includes("fill")) {
        if ([
            void 0,
            null,
            ""
        ].includes(getValue()) || $f347e48613385d9c$var$isCheckbox(el) && Array.isArray(getValue()) || el.tagName.toLowerCase() === "select" && el.multiple) setValue($f347e48613385d9c$var$getInputValue(el, modifiers, {
            target: el
        }, getValue()));
    }
    if (!el._x_removeModelListeners) el._x_removeModelListeners = {};
    el._x_removeModelListeners["default"] = removeListener;
    cleanup2(()=>el._x_removeModelListeners["default"]());
    if (el.form) {
        let removeResetListener = $f347e48613385d9c$var$on(el.form, "reset", [], (e)=>{
            $f347e48613385d9c$var$nextTick(()=>el._x_model && el._x_model.set($f347e48613385d9c$var$getInputValue(el, modifiers, {
                    target: el
                }, getValue())));
        });
        cleanup2(()=>removeResetListener());
    }
    el._x_model = {
        get () {
            return getValue();
        },
        set (value) {
            setValue(value);
        }
    };
    el._x_forceModelUpdate = (value)=>{
        if (value === void 0 && typeof expression === "string" && expression.match(/\./)) value = "";
        window.fromModel = true;
        $f347e48613385d9c$var$mutateDom(()=>$f347e48613385d9c$var$bind(el, "value", value));
        delete window.fromModel;
    };
    effect3(()=>{
        let value = getValue();
        if (modifiers.includes("unintrusive") && document.activeElement.isSameNode(el)) return;
        el._x_forceModelUpdate(value);
    });
});
function $f347e48613385d9c$var$getInputValue(el, modifiers, event, currentValue) {
    return $f347e48613385d9c$var$mutateDom(()=>{
        if (event instanceof CustomEvent && event.detail !== void 0) return event.detail !== null && event.detail !== void 0 ? event.detail : event.target.value;
        else if ($f347e48613385d9c$var$isCheckbox(el)) {
            if (Array.isArray(currentValue)) {
                let newValue = null;
                if (modifiers.includes("number")) newValue = $f347e48613385d9c$var$safeParseNumber(event.target.value);
                else if (modifiers.includes("boolean")) newValue = $f347e48613385d9c$var$safeParseBoolean(event.target.value);
                else newValue = event.target.value;
                return event.target.checked ? currentValue.includes(newValue) ? currentValue : currentValue.concat([
                    newValue
                ]) : currentValue.filter((el2)=>!$f347e48613385d9c$var$checkedAttrLooseCompare2(el2, newValue));
            } else return event.target.checked;
        } else if (el.tagName.toLowerCase() === "select" && el.multiple) {
            if (modifiers.includes("number")) return Array.from(event.target.selectedOptions).map((option)=>{
                let rawValue = option.value || option.text;
                return $f347e48613385d9c$var$safeParseNumber(rawValue);
            });
            else if (modifiers.includes("boolean")) return Array.from(event.target.selectedOptions).map((option)=>{
                let rawValue = option.value || option.text;
                return $f347e48613385d9c$var$safeParseBoolean(rawValue);
            });
            return Array.from(event.target.selectedOptions).map((option)=>{
                return option.value || option.text;
            });
        } else {
            let newValue;
            if ($f347e48613385d9c$var$isRadio(el)) {
                if (event.target.checked) newValue = event.target.value;
                else newValue = currentValue;
            } else newValue = event.target.value;
            if (modifiers.includes("number")) return $f347e48613385d9c$var$safeParseNumber(newValue);
            else if (modifiers.includes("boolean")) return $f347e48613385d9c$var$safeParseBoolean(newValue);
            else if (modifiers.includes("trim")) return newValue.trim();
            else return newValue;
        }
    });
}
function $f347e48613385d9c$var$safeParseNumber(rawValue) {
    let number = rawValue ? parseFloat(rawValue) : null;
    return $f347e48613385d9c$var$isNumeric2(number) ? number : rawValue;
}
function $f347e48613385d9c$var$checkedAttrLooseCompare2(valueA, valueB) {
    return valueA == valueB;
}
function $f347e48613385d9c$var$isNumeric2(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
function $f347e48613385d9c$var$isGetterSetter(value) {
    return value !== null && typeof value === "object" && typeof value.get === "function" && typeof value.set === "function";
}
// packages/alpinejs/src/directives/x-cloak.js
$f347e48613385d9c$var$directive("cloak", (el)=>queueMicrotask(()=>$f347e48613385d9c$var$mutateDom(()=>el.removeAttribute($f347e48613385d9c$var$prefix("cloak")))));
// packages/alpinejs/src/directives/x-init.js
$f347e48613385d9c$var$addInitSelector(()=>`[${$f347e48613385d9c$var$prefix("init")}]`);
$f347e48613385d9c$var$directive("init", $f347e48613385d9c$var$skipDuringClone((el, { expression: expression }, { evaluate: evaluate2 })=>{
    if (typeof expression === "string") return !!expression.trim() && evaluate2(expression, {}, false);
    return evaluate2(expression, {}, false);
}));
// packages/alpinejs/src/directives/x-text.js
$f347e48613385d9c$var$directive("text", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2 })=>{
    let evaluate2 = evaluateLater2(expression);
    effect3(()=>{
        evaluate2((value)=>{
            $f347e48613385d9c$var$mutateDom(()=>{
                el.textContent = value;
            });
        });
    });
});
// packages/alpinejs/src/directives/x-html.js
$f347e48613385d9c$var$directive("html", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2 })=>{
    let evaluate2 = evaluateLater2(expression);
    effect3(()=>{
        evaluate2((value)=>{
            $f347e48613385d9c$var$mutateDom(()=>{
                el.innerHTML = value;
                el._x_ignoreSelf = true;
                $f347e48613385d9c$var$initTree(el);
                delete el._x_ignoreSelf;
            });
        });
    });
});
// packages/alpinejs/src/directives/x-bind.js
$f347e48613385d9c$var$mapAttributes($f347e48613385d9c$var$startingWith(":", $f347e48613385d9c$var$into($f347e48613385d9c$var$prefix("bind:"))));
var $f347e48613385d9c$var$handler2 = (el, { value: value, modifiers: modifiers, expression: expression, original: original }, { effect: effect3, cleanup: cleanup2 })=>{
    if (!value) {
        let bindingProviders = {};
        $f347e48613385d9c$var$injectBindingProviders(bindingProviders);
        let getBindings = $f347e48613385d9c$var$evaluateLater(el, expression);
        getBindings((bindings)=>{
            $f347e48613385d9c$var$applyBindingsObject(el, bindings, original);
        }, {
            scope: bindingProviders
        });
        return;
    }
    if (value === "key") return $f347e48613385d9c$var$storeKeyForXFor(el, expression);
    if (el._x_inlineBindings && el._x_inlineBindings[value] && el._x_inlineBindings[value].extract) return;
    let evaluate2 = $f347e48613385d9c$var$evaluateLater(el, expression);
    effect3(()=>evaluate2((result)=>{
            if (result === void 0 && typeof expression === "string" && expression.match(/\./)) result = "";
            $f347e48613385d9c$var$mutateDom(()=>$f347e48613385d9c$var$bind(el, value, result, modifiers));
        }));
    cleanup2(()=>{
        el._x_undoAddedClasses && el._x_undoAddedClasses();
        el._x_undoAddedStyles && el._x_undoAddedStyles();
    });
};
$f347e48613385d9c$var$handler2.inline = (el, { value: value, modifiers: modifiers, expression: expression })=>{
    if (!value) return;
    if (!el._x_inlineBindings) el._x_inlineBindings = {};
    el._x_inlineBindings[value] = {
        expression: expression,
        extract: false
    };
};
$f347e48613385d9c$var$directive("bind", $f347e48613385d9c$var$handler2);
function $f347e48613385d9c$var$storeKeyForXFor(el, expression) {
    el._x_keyExpression = expression;
}
// packages/alpinejs/src/directives/x-data.js
$f347e48613385d9c$var$addRootSelector(()=>`[${$f347e48613385d9c$var$prefix("data")}]`);
$f347e48613385d9c$var$directive("data", (el, { expression: expression }, { cleanup: cleanup2 })=>{
    if ($f347e48613385d9c$var$shouldSkipRegisteringDataDuringClone(el)) return;
    expression = expression === "" ? "{}" : expression;
    let magicContext = {};
    $f347e48613385d9c$var$injectMagics(magicContext, el);
    let dataProviderContext = {};
    $f347e48613385d9c$var$injectDataProviders(dataProviderContext, magicContext);
    let data2 = $f347e48613385d9c$var$evaluate(el, expression, {
        scope: dataProviderContext
    });
    if (data2 === void 0 || data2 === true) data2 = {};
    $f347e48613385d9c$var$injectMagics(data2, el);
    let reactiveData = $f347e48613385d9c$var$reactive(data2);
    $f347e48613385d9c$var$initInterceptors(reactiveData);
    let undo = $f347e48613385d9c$var$addScopeToNode(el, reactiveData);
    reactiveData["init"] && $f347e48613385d9c$var$evaluate(el, reactiveData["init"]);
    cleanup2(()=>{
        reactiveData["destroy"] && $f347e48613385d9c$var$evaluate(el, reactiveData["destroy"]);
        undo();
    });
});
$f347e48613385d9c$var$interceptClone((from, to)=>{
    if (from._x_dataStack) {
        to._x_dataStack = from._x_dataStack;
        to.setAttribute("data-has-alpine-state", true);
    }
});
function $f347e48613385d9c$var$shouldSkipRegisteringDataDuringClone(el) {
    if (!$f347e48613385d9c$var$isCloning) return false;
    if ($f347e48613385d9c$var$isCloningLegacy) return true;
    return el.hasAttribute("data-has-alpine-state");
}
// packages/alpinejs/src/directives/x-show.js
$f347e48613385d9c$var$directive("show", (el, { modifiers: modifiers, expression: expression }, { effect: effect3 })=>{
    let evaluate2 = $f347e48613385d9c$var$evaluateLater(el, expression);
    if (!el._x_doHide) el._x_doHide = ()=>{
        $f347e48613385d9c$var$mutateDom(()=>{
            el.style.setProperty("display", "none", modifiers.includes("important") ? "important" : void 0);
        });
    };
    if (!el._x_doShow) el._x_doShow = ()=>{
        $f347e48613385d9c$var$mutateDom(()=>{
            if (el.style.length === 1 && el.style.display === "none") el.removeAttribute("style");
            else el.style.removeProperty("display");
        });
    };
    let hide = ()=>{
        el._x_doHide();
        el._x_isShown = false;
    };
    let show = ()=>{
        el._x_doShow();
        el._x_isShown = true;
    };
    let clickAwayCompatibleShow = ()=>setTimeout(show);
    let toggle = $f347e48613385d9c$var$once((value)=>value ? show() : hide(), (value)=>{
        if (typeof el._x_toggleAndCascadeWithTransitions === "function") el._x_toggleAndCascadeWithTransitions(el, value, show, hide);
        else value ? clickAwayCompatibleShow() : hide();
    });
    let oldValue;
    let firstTime = true;
    effect3(()=>evaluate2((value)=>{
            if (!firstTime && value === oldValue) return;
            if (modifiers.includes("immediate")) value ? clickAwayCompatibleShow() : hide();
            toggle(value);
            oldValue = value;
            firstTime = false;
        }));
});
// packages/alpinejs/src/directives/x-for.js
$f347e48613385d9c$var$directive("for", (el, { expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    let iteratorNames = $f347e48613385d9c$var$parseForExpression(expression);
    let evaluateItems = $f347e48613385d9c$var$evaluateLater(el, iteratorNames.items);
    let evaluateKey = $f347e48613385d9c$var$evaluateLater(el, // the x-bind:key expression is stored for our use instead of evaluated.
    el._x_keyExpression || "index");
    el._x_prevKeys = [];
    el._x_lookup = {};
    effect3(()=>$f347e48613385d9c$var$loop(el, iteratorNames, evaluateItems, evaluateKey));
    cleanup2(()=>{
        Object.values(el._x_lookup).forEach((el2)=>$f347e48613385d9c$var$mutateDom(()=>{
                $f347e48613385d9c$var$destroyTree(el2);
                el2.remove();
            }));
        delete el._x_prevKeys;
        delete el._x_lookup;
    });
});
function $f347e48613385d9c$var$loop(el, iteratorNames, evaluateItems, evaluateKey) {
    let isObject2 = (i)=>typeof i === "object" && !Array.isArray(i);
    let templateEl = el;
    evaluateItems((items)=>{
        if ($f347e48613385d9c$var$isNumeric3(items) && items >= 0) items = Array.from(Array(items).keys(), (i)=>i + 1);
        if (items === void 0) items = [];
        let lookup = el._x_lookup;
        let prevKeys = el._x_prevKeys;
        let scopes = [];
        let keys = [];
        if (isObject2(items)) items = Object.entries(items).map(([key, value])=>{
            let scope2 = $f347e48613385d9c$var$getIterationScopeVariables(iteratorNames, value, key, items);
            evaluateKey((value2)=>{
                if (keys.includes(value2)) $f347e48613385d9c$var$warn("Duplicate key on x-for", el);
                keys.push(value2);
            }, {
                scope: {
                    index: key,
                    ...scope2
                }
            });
            scopes.push(scope2);
        });
        else for(let i = 0; i < items.length; i++){
            let scope2 = $f347e48613385d9c$var$getIterationScopeVariables(iteratorNames, items[i], i, items);
            evaluateKey((value)=>{
                if (keys.includes(value)) $f347e48613385d9c$var$warn("Duplicate key on x-for", el);
                keys.push(value);
            }, {
                scope: {
                    index: i,
                    ...scope2
                }
            });
            scopes.push(scope2);
        }
        let adds = [];
        let moves = [];
        let removes = [];
        let sames = [];
        for(let i = 0; i < prevKeys.length; i++){
            let key = prevKeys[i];
            if (keys.indexOf(key) === -1) removes.push(key);
        }
        prevKeys = prevKeys.filter((key)=>!removes.includes(key));
        let lastKey = "template";
        for(let i = 0; i < keys.length; i++){
            let key = keys[i];
            let prevIndex = prevKeys.indexOf(key);
            if (prevIndex === -1) {
                prevKeys.splice(i, 0, key);
                adds.push([
                    lastKey,
                    i
                ]);
            } else if (prevIndex !== i) {
                let keyInSpot = prevKeys.splice(i, 1)[0];
                let keyForSpot = prevKeys.splice(prevIndex - 1, 1)[0];
                prevKeys.splice(i, 0, keyForSpot);
                prevKeys.splice(prevIndex, 0, keyInSpot);
                moves.push([
                    keyInSpot,
                    keyForSpot
                ]);
            } else sames.push(key);
            lastKey = key;
        }
        for(let i = 0; i < removes.length; i++){
            let key = removes[i];
            if (!(key in lookup)) continue;
            $f347e48613385d9c$var$mutateDom(()=>{
                $f347e48613385d9c$var$destroyTree(lookup[key]);
                lookup[key].remove();
            });
            delete lookup[key];
        }
        for(let i = 0; i < moves.length; i++){
            let [keyInSpot, keyForSpot] = moves[i];
            let elInSpot = lookup[keyInSpot];
            let elForSpot = lookup[keyForSpot];
            let marker = document.createElement("div");
            $f347e48613385d9c$var$mutateDom(()=>{
                if (!elForSpot) $f347e48613385d9c$var$warn(`x-for ":key" is undefined or invalid`, templateEl, keyForSpot, lookup);
                elForSpot.after(marker);
                elInSpot.after(elForSpot);
                elForSpot._x_currentIfEl && elForSpot.after(elForSpot._x_currentIfEl);
                marker.before(elInSpot);
                elInSpot._x_currentIfEl && elInSpot.after(elInSpot._x_currentIfEl);
                marker.remove();
            });
            elForSpot._x_refreshXForScope(scopes[keys.indexOf(keyForSpot)]);
        }
        for(let i = 0; i < adds.length; i++){
            let [lastKey2, index] = adds[i];
            let lastEl = lastKey2 === "template" ? templateEl : lookup[lastKey2];
            if (lastEl._x_currentIfEl) lastEl = lastEl._x_currentIfEl;
            let scope2 = scopes[index];
            let key = keys[index];
            let clone2 = document.importNode(templateEl.content, true).firstElementChild;
            let reactiveScope = $f347e48613385d9c$var$reactive(scope2);
            $f347e48613385d9c$var$addScopeToNode(clone2, reactiveScope, templateEl);
            clone2._x_refreshXForScope = (newScope)=>{
                Object.entries(newScope).forEach(([key2, value])=>{
                    reactiveScope[key2] = value;
                });
            };
            $f347e48613385d9c$var$mutateDom(()=>{
                lastEl.after(clone2);
                $f347e48613385d9c$var$skipDuringClone(()=>$f347e48613385d9c$var$initTree(clone2))();
            });
            if (typeof key === "object") $f347e48613385d9c$var$warn("x-for key cannot be an object, it must be a string or an integer", templateEl);
            lookup[key] = clone2;
        }
        for(let i = 0; i < sames.length; i++)lookup[sames[i]]._x_refreshXForScope(scopes[keys.indexOf(sames[i])]);
        templateEl._x_prevKeys = keys;
    });
}
function $f347e48613385d9c$var$parseForExpression(expression) {
    let forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
    let stripParensRE = /^\s*\(|\)\s*$/g;
    let forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
    let inMatch = expression.match(forAliasRE);
    if (!inMatch) return;
    let res = {};
    res.items = inMatch[2].trim();
    let item = inMatch[1].replace(stripParensRE, "").trim();
    let iteratorMatch = item.match(forIteratorRE);
    if (iteratorMatch) {
        res.item = item.replace(forIteratorRE, "").trim();
        res.index = iteratorMatch[1].trim();
        if (iteratorMatch[2]) res.collection = iteratorMatch[2].trim();
    } else res.item = item;
    return res;
}
function $f347e48613385d9c$var$getIterationScopeVariables(iteratorNames, item, index, items) {
    let scopeVariables = {};
    if (/^\[.*\]$/.test(iteratorNames.item) && Array.isArray(item)) {
        let names = iteratorNames.item.replace("[", "").replace("]", "").split(",").map((i)=>i.trim());
        names.forEach((name, i)=>{
            scopeVariables[name] = item[i];
        });
    } else if (/^\{.*\}$/.test(iteratorNames.item) && !Array.isArray(item) && typeof item === "object") {
        let names = iteratorNames.item.replace("{", "").replace("}", "").split(",").map((i)=>i.trim());
        names.forEach((name)=>{
            scopeVariables[name] = item[name];
        });
    } else scopeVariables[iteratorNames.item] = item;
    if (iteratorNames.index) scopeVariables[iteratorNames.index] = index;
    if (iteratorNames.collection) scopeVariables[iteratorNames.collection] = items;
    return scopeVariables;
}
function $f347e48613385d9c$var$isNumeric3(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
// packages/alpinejs/src/directives/x-ref.js
function $f347e48613385d9c$var$handler3() {}
$f347e48613385d9c$var$handler3.inline = (el, { expression: expression }, { cleanup: cleanup2 })=>{
    let root = $f347e48613385d9c$var$closestRoot(el);
    if (!root._x_refs) root._x_refs = {};
    root._x_refs[expression] = el;
    cleanup2(()=>delete root._x_refs[expression]);
};
$f347e48613385d9c$var$directive("ref", $f347e48613385d9c$var$handler3);
// packages/alpinejs/src/directives/x-if.js
$f347e48613385d9c$var$directive("if", (el, { expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    if (el.tagName.toLowerCase() !== "template") $f347e48613385d9c$var$warn("x-if can only be used on a <template> tag", el);
    let evaluate2 = $f347e48613385d9c$var$evaluateLater(el, expression);
    let show = ()=>{
        if (el._x_currentIfEl) return el._x_currentIfEl;
        let clone2 = el.content.cloneNode(true).firstElementChild;
        $f347e48613385d9c$var$addScopeToNode(clone2, {}, el);
        $f347e48613385d9c$var$mutateDom(()=>{
            el.after(clone2);
            $f347e48613385d9c$var$skipDuringClone(()=>$f347e48613385d9c$var$initTree(clone2))();
        });
        el._x_currentIfEl = clone2;
        el._x_undoIf = ()=>{
            $f347e48613385d9c$var$mutateDom(()=>{
                $f347e48613385d9c$var$destroyTree(clone2);
                clone2.remove();
            });
            delete el._x_currentIfEl;
        };
        return clone2;
    };
    let hide = ()=>{
        if (!el._x_undoIf) return;
        el._x_undoIf();
        delete el._x_undoIf;
    };
    effect3(()=>evaluate2((value)=>{
            value ? show() : hide();
        }));
    cleanup2(()=>el._x_undoIf && el._x_undoIf());
});
// packages/alpinejs/src/directives/x-id.js
$f347e48613385d9c$var$directive("id", (el, { expression: expression }, { evaluate: evaluate2 })=>{
    let names = evaluate2(expression);
    names.forEach((name)=>$f347e48613385d9c$var$setIdRoot(el, name));
});
$f347e48613385d9c$var$interceptClone((from, to)=>{
    if (from._x_ids) to._x_ids = from._x_ids;
});
// packages/alpinejs/src/directives/x-on.js
$f347e48613385d9c$var$mapAttributes($f347e48613385d9c$var$startingWith("@", $f347e48613385d9c$var$into($f347e48613385d9c$var$prefix("on:"))));
$f347e48613385d9c$var$directive("on", $f347e48613385d9c$var$skipDuringClone((el, { value: value, modifiers: modifiers, expression: expression }, { cleanup: cleanup2 })=>{
    let evaluate2 = expression ? $f347e48613385d9c$var$evaluateLater(el, expression) : ()=>{};
    if (el.tagName.toLowerCase() === "template") {
        if (!el._x_forwardEvents) el._x_forwardEvents = [];
        if (!el._x_forwardEvents.includes(value)) el._x_forwardEvents.push(value);
    }
    let removeListener = $f347e48613385d9c$var$on(el, value, modifiers, (e)=>{
        evaluate2(()=>{}, {
            scope: {
                "$event": e
            },
            params: [
                e
            ]
        });
    });
    cleanup2(()=>removeListener());
}));
// packages/alpinejs/src/directives/index.js
$f347e48613385d9c$var$warnMissingPluginDirective("Collapse", "collapse", "collapse");
$f347e48613385d9c$var$warnMissingPluginDirective("Intersect", "intersect", "intersect");
$f347e48613385d9c$var$warnMissingPluginDirective("Focus", "trap", "focus");
$f347e48613385d9c$var$warnMissingPluginDirective("Mask", "mask", "mask");
function $f347e48613385d9c$var$warnMissingPluginDirective(name, directiveName, slug) {
    $f347e48613385d9c$var$directive(directiveName, (el)=>$f347e48613385d9c$var$warn(`You can't use [x-${directiveName}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
}
// packages/alpinejs/src/index.js
$f347e48613385d9c$var$alpine_default.setEvaluator($f347e48613385d9c$var$normalEvaluator);
$f347e48613385d9c$var$alpine_default.setReactivityEngine({
    reactive: $f347e48613385d9c$var$reactive2,
    effect: $f347e48613385d9c$var$effect2,
    release: $f347e48613385d9c$var$stop,
    raw: $f347e48613385d9c$var$toRaw
});
var $f347e48613385d9c$export$b7ee041e4ad2afec = $f347e48613385d9c$var$alpine_default;
// packages/alpinejs/builds/module.js
var $f347e48613385d9c$export$2e2bcd8739ae039 = $f347e48613385d9c$export$b7ee041e4ad2afec;


/**
 * Creates the store for the appearance (light / dark theme).
 *
 * @param {import('alpinejs').Alpine} Alpine The alpine instance.
 */ function $0c531eb0eb863e5f$export$2e2bcd8739ae039(Alpine) {
    Alpine.store("appearance", {
        theme: Alpine.$persist("system").as("theme"),
        init () {
            Alpine.effect(()=>{
                const root = document.documentElement;
                root.setAttribute("data-no-transition", "");
                root.setAttribute("data-theme", this.theme);
                setTimeout(()=>root.removeAttribute("data-no-transition"));
            });
        }
    });
}


/**
 * Provides the theme switcher menu component data.
 * @param {import("alpinejs").Alpine} Alpine The Alpine instance.
 */ function $f075c935b71465ef$export$2e2bcd8739ae039(Alpine) {
    Alpine.data("themeSwitcher", ()=>({
            open: false,
            focusedIdx: 0,
            themes: [],
            openMenu () {
                this.open = true;
                this.focusOnNextTick(this.themes.indexOf(this.$store.appearance.theme));
            },
            closeMenu ({ restoreFocus: restoreFocus = true } = {}) {
                this.open = false;
                restoreFocus && this.$refs.trigger.focus();
            },
            onFocusOut (event) {
                if (this.open && !this.$refs.menu.contains(event.relatedTarget)) this.$nextTick(()=>this.closeMenu({
                        restoreFocus: false
                    }));
            },
            focusNext () {
                this.focusOnNextTick((this.focusedIdx + 1) % this.themes.length);
            },
            focusPrevious () {
                const { length: length } = this.themes;
                this.focusOnNextTick((this.focusedIdx - 1 + length) % length);
            },
            selectTheme (theme, { keepOpen: keepOpen = false } = {}) {
                this.$store.appearance.theme = theme;
                !keepOpen && this.closeMenu();
            },
            focusOnNextTick (index) {
                this.focusedIdx = index;
                this.$nextTick(()=>{
                    this.$refs.menu.querySelector('[data-focused="true"]')?.focus();
                });
            }
        }));
}


const $8d06e390c6380202$var$baseUrl = document.currentScript?.getAttribute("data-base") ?? "/";
const $8d06e390c6380202$var$indexJsonUrl = $8d06e390c6380202$var$baseUrl + "index.json";
function $8d06e390c6380202$export$2e2bcd8739ae039(Alpine) {
    Alpine.store("bookmarks", {
        /**
     * The index of all notes.
     * A key-value map of note URLs to note titles.
     * @type {Record<string, string>}
     */ index: {},
        /**
     * The list of bookmarked notes.
     * @type {string[]}
     */ items: Alpine.$persist([]).as("favorites"),
        async init () {
            this.index = await fetch($8d06e390c6380202$var$indexJsonUrl).then((r)=>r.json()).catch(()=>{
                console.error("Could not fetch notes index");
                return {};
            });
            this.cleanUpBookmarks();
        },
        is (id) {
            return this.items.includes(id);
        },
        /**
     * Toggles the bookmark status of a note.
     * @param {string} id
     */ toggle (id) {
            if (this.items.includes(id)) this.items = this.items.filter((bkm)=>bkm !== id);
            else this.items.push(id);
        },
        cleanUpBookmarks () {
            if (Object.keys(this.index).length === 0) return;
            this.items = this.items.filter((id)=>!!this.index[id]);
        }
    });
}


/**
 * Creates the store for the collapsible sidebar.
 *
 * @param {import('alpinejs').Alpine} Alpine The alpine instance.
 */ function $4bb895f7d67681bf$export$2e2bcd8739ae039(Alpine) {
    Alpine.store("nav", {
        open: false,
        toggle (value) {
            this.open = value ?? !this.open;
            if (this.open) Alpine.store("panel").toggle(false);
        }
    });
}


/**
 * Provides the store for the panel overlay on mobile.
 *
 * @param {import("alpinejs").Alpine} Alpine The Alpine instance.
 */ function $0e088e5827e61707$export$2e2bcd8739ae039(Alpine) {
    Alpine.store("panel", {
        withOverlay: false,
        open: false,
        panelRef: null,
        overlayPanelRef: null,
        init () {
            this.panelRef = document.querySelector("[data-ref=panel]");
            this.overlayPanelRef = document.querySelector("[data-ref=overlayPanel]");
            if (!this.panelRef || !this.overlayPanelRef) return;
            $0e088e5827e61707$var$observeMediaQuery("(min-width: 64em)", (matches)=>{
                this.withOverlay = !matches;
                this.open = false;
                const source = this.withOverlay ? this.panelRef : this.overlayPanelRef;
                const target = this.withOverlay ? this.overlayPanelRef : this.panelRef;
                if (source.firstElementChild) target.append(source.firstElementChild);
            });
        },
        onOverlayClick (event) {
            const isSelf = event.target === event.currentTarget;
            const isSameTabLink = event.target.tagName === "A" && event.target.getAttribute("target") !== "_blank";
            this.toggle(!(isSelf || isSameTabLink));
        },
        toggle (value) {
            this.open = value ?? !this.open;
            if (this.open) Alpine.store("nav").toggle(false);
        }
    });
}
function $0e088e5827e61707$var$observeMediaQuery(query, callback) {
    const mediaQuery = window.matchMedia(query);
    const handle = ()=>callback(mediaQuery.matches);
    mediaQuery.addEventListener("change", handle);
    handle();
    return ()=>mediaQuery.removeEventListener("change", handle);
}



var $ewJru = parcelRequire("ewJru");
/**
 * Creates the collapsible data for collapsing sections.
 * @param {import("alpinejs").Alpine} Alpine The alpine instance.
 */ function $7b0256c106492184$export$2e2bcd8739ae039(Alpine) {
    Alpine.data("collapsible", (key, defaultExpanded)=>({
            expanded: Alpine.$persist(defaultExpanded).as(`collapsible:${key}`).using(sessionStorage),
            init () {
                if (this.$el.querySelector("[aria-current=page]")) this.expanded = true;
            },
            toggle () {
                this.expanded = !this.expanded;
            }
        }));
}


const $d104974fa1c57088$var$tags = new Set([
    "INPUT",
    "TEXTAREA",
    "SELECT"
]);
function $d104974fa1c57088$export$2e2bcd8739ae039(Alpine) {
    Alpine.store("hotkeys", {
        async register (shortcut, callback) {
            document.addEventListener("keydown", (event)=>{
                if (event.defaultPrevented) return;
                if (event.key !== shortcut || event.metaKey || event.ctrlKey) return;
                if ($d104974fa1c57088$var$tags.has(document.activeElement?.tagName)) return;
                event.preventDefault();
                callback();
            });
        }
    });
}


/**
 * Register the scroll container data object.
 *
 * @param {import("alpinejs").Alpine} Alpine The alpine instance.
 */ function $b8dd5f968bd2f1b6$export$2e2bcd8739ae039(Alpine) {
    Alpine.data("scrollContainer", (identifier)=>({
            key: `scroll-position:${identifier}`,
            init () {
                const value = sessionStorage.getItem(this.key);
                setTimeout(()=>this.$el.scrollTop = parseInt(value, 10));
            },
            container: {
                ["@scroll.debounce"] (event) {
                    sessionStorage.setItem(this.key, event.target.scrollTop);
                }
            }
        }));
}


/**
 * Registers the WindowScroll object for x-bind.
 *
 * @param {import("alpinejs").Alpine} Alpine The Alpine instance.
 */ function $c2c32f4d15da0450$export$2e2bcd8739ae039(Alpine) {
    Alpine.bind("WindowScroll", ()=>({
            ["@scroll.window"] () {
                this.$el.setAttribute("data-scrolled", window.document.documentElement.scrollTop > 0);
            }
        }));
}


/**
 * Alpine Persist plugin but with error handling.
 * See https://github.com/alpinejs/alpine/blob/main/packages/persist/src/index.js
 *
 * @param {import("alpinejs").Alpine} Alpine The alpine instance.
 */ function $66f82a822e787a89$export$2e2bcd8739ae039(Alpine) {
    let persist = ()=>{
        let alias;
        let storage = localStorage;
        return Alpine.interceptor((initialValue, getter, setter, path, key)=>{
            let lookup = alias || `_x_${path}`;
            let initial = $66f82a822e787a89$var$storageHas(lookup, storage) ? $66f82a822e787a89$var$storageGet(lookup, storage) : initialValue;
            setter(initial);
            Alpine.effect(()=>{
                let value = getter();
                $66f82a822e787a89$var$storageSet(lookup, value, storage);
                setter(value);
            });
            return initial;
        }, (func)=>{
            func.as = (key)=>{
                alias = key;
                return func;
            }, func.using = (target)=>{
                storage = target;
                return func;
            };
        });
    };
    Object.defineProperty(Alpine, "$persist", {
        get: ()=>persist()
    });
    Alpine.magic("persist", persist);
    Alpine.persist = (key, { get: get, set: set }, storage = localStorage)=>{
        let initial = $66f82a822e787a89$var$storageHas(key, storage) ? $66f82a822e787a89$var$storageGet(key, storage) : get();
        set(initial);
        Alpine.effect(()=>{
            let value = get();
            $66f82a822e787a89$var$storageSet(key, value, storage);
            set(value);
        });
    };
}
function $66f82a822e787a89$var$storageHas(key, storage) {
    const item = storage.getItem(key);
    const isValid = item !== null && $66f82a822e787a89$var$canParse(item);
    return isValid;
}
function $66f82a822e787a89$var$storageGet(key, storage) {
    return JSON.parse(storage.getItem(key, storage));
}
function $66f82a822e787a89$var$storageSet(key, value, storage) {
    storage.setItem(key, JSON.stringify(value));
}
function $66f82a822e787a89$var$canParse(value) {
    try {
        JSON.parse(value);
        return true;
    } catch (e) {
        return false;
    }
}


/**
 * Provides a data object to copy text to the clipboard.
 *
 * @param {import("alpinejs").Alpine} Alpine The Alpine instance.
 */ function $a7f0716e3e6baee3$export$2e2bcd8739ae039(Alpine) {
    Alpine.data("copyToClipboard", ()=>({
            copied: false,
            copyBtn: {
                ":data-copied" () {
                    return `${this.copied}`;
                },
                async ["@click"] () {
                    const text = this.$el.previousElementSibling.innerText;
                    await navigator.clipboard.writeText(text);
                    this.copied = true;
                    setTimeout(()=>this.copied = false, 1500);
                }
            }
        }));
}


/**
 * Creates the data for the table of contents.
 *
 * @param {import('alpinejs').Alpine} Alpine The alpine instance.
 */ function $73724c2edf7a47bd$export$2e2bcd8739ae039(Alpine) {
    Alpine.data("toc", ()=>({
            activeId: null,
            indicator: {
                start: 0,
                size: 0
            },
            _links: undefined,
            _headings: undefined,
            _nextHash: window.location.hash.slice(1),
            _scrollTimer: 0,
            _resizeObserver: null,
            get indicatorStyles () {
                return {
                    "--toc-indicator-start": `${this.indicator.start}px`,
                    "--toc-indicator-size": `${this.indicator.size}px`
                };
            },
            init () {
                this._links = [
                    ...this.$el.querySelectorAll("a")
                ];
                this._headings = this._links.map((link)=>link.getAttribute("href").slice(1)).map((id)=>document.getElementById(id));
                // Initialize trigger in case the user loads the page for the first time
                // without a restored scroll position or hash.
                this.onScroll(false);
                // Ensure indicator is updated when mobile panel is opened
                this._resizeObserver = new ResizeObserver(()=>this._calcIndicator());
                this._resizeObserver.observe(this.$el);
            },
            destroy () {
                this._resizeObserver?.disconnect();
            },
            onNavigate (id) {
                // Hash will be used the next time a scroll event is triggered.
                this._nextHash = id;
                // If the hash target is already at the correct position,
                // or scrolling to the target is not possible (e.g. the target is at the bottom of the page
                // and the user is already at the bottom), we trigger the scroll event manually.
                // The timer will be canceled if onScroll() is called by the scroll event.
                this._scrollTimer = window.setTimeout(()=>this.onScroll(true), 50);
            },
            onScroll (throttled = true) {
                window.clearTimeout(this._scrollTimer);
                if (throttled) // We throttle the onScroll event for better performance (via AlpineJS).
                // The last few scroll events will be ignored because of that,
                // resulting in a incorrect position calculation.
                // => Trigger a recalculation with a short delay to fix this.
                this._scrollTimer = window.setTimeout(()=>this.onScroll(false), 60);
                this._calcPosition();
                this._calcIndicator();
            },
            _calcPosition () {
                const topOffset = this._calcTopOffset();
                const headings = this._headings.map((heading)=>{
                    const { top: top, height: height } = heading.getBoundingClientRect();
                    // We activate the heading a bit before it reaches the top.
                    // There is no scientific reason for this value. 🤷‍♂️
                    const allowedArea = topOffset + 2 * height;
                    return {
                        id: heading.id,
                        pos: top,
                        isInFocusAreaOrAbove: top <= allowedArea
                    };
                });
                // If a valid next hash is available, we use it instead of the scroll position
                // because for headings at the bottom of the page, the scroll position is not correct.
                const ids = headings.map((x)=>x.id);
                const idFromNextHash = this._getValidIdFromNextHash(ids);
                if (idFromNextHash) {
                    this.activeId = idFromNextHash;
                    this._nextHash = undefined;
                    // Scrolling to a hash target happens sychronously (we don't use smooth scrolling).
                    // Therefore we don't need to trigger a debounced scroll event,
                    // which would overwrite the position.
                    window.clearTimeout(this._scrollTimer);
                    return;
                }
                // If the user is at the bottom of the page and the page ends
                // with short chapters, the last (few) heading(s) might never be activated.
                // which feels wrong (but many websites have this issue).
                // To fix this, we mark the last heading as active if the user is at the bottom.
                // As a result, the indicator may "jump" a bit when scrolling around
                // which isn't ideal but probably better than the other issue (who knows).
                // We only do this if the page is scrollable, because for short pages
                // that are not scrollable we shouldn't mark the last heading as active.
                const pos = window.scrollY > 0 ? window.innerHeight + window.scrollY : 0;
                const scrollOffset = 10; // Just some random value that feels right.
                const isNearBottom = pos >= document.body.offsetHeight - scrollOffset;
                if (isNearBottom) {
                    this.activeId = headings.at(-1)?.id;
                    return;
                }
                // Now we find the last heading that is not below the focus area
                this.activeId = headings.filter((x)=>x.isInFocusAreaOrAbove).sort((a, b)=>b.pos - a.pos).at(0)?.id ?? null;
            },
            _getValidIdFromNextHash (validIds) {
                const isValid = !!this._nextHash && validIds.includes(this._nextHash) && // Reloading the page with a hash will not focus the heading
                // and restore the scroll position (tested in Brave). In this case,
                // we should not use the hash.
                document.activeElement?.id === this._nextHash;
                return isValid ? this._nextHash : null;
            },
            _calcIndicator () {
                const activeHref = `#${this.activeId}`;
                const activeLink = this.activeId ? this._links.find((x)=>x.getAttribute("href") == activeHref) : undefined;
                if (!activeLink) {
                    this.indicator = {
                        start: 0,
                        size: 0
                    };
                    return;
                }
                const rootElRect = activeLink.closest("ul").getBoundingClientRect();
                const linkRect = activeLink.getBoundingClientRect();
                this.indicator = {
                    start: linkRect.y - rootElRect.y,
                    size: linkRect.height
                };
            },
            _calcTopOffset () {
                // The headings have a scroll margin because of the sticky header.
                // All headings should have the same scroll margin, so it should be fine
                // to use the first heading's scroll margin.
                const style = this._headings.length ? window.getComputedStyle(this._headings[0]) : undefined;
                return style ? parseInt(style.scrollMarginBlockStart, 10) : 0;
            }
        }));
}


(0, $f347e48613385d9c$export$2e2bcd8739ae039).plugin((0, $66f82a822e787a89$export$2e2bcd8739ae039));
(0, $0c531eb0eb863e5f$export$2e2bcd8739ae039)((0, $f347e48613385d9c$export$2e2bcd8739ae039));
(0, $f075c935b71465ef$export$2e2bcd8739ae039)((0, $f347e48613385d9c$export$2e2bcd8739ae039));
(0, $8d06e390c6380202$export$2e2bcd8739ae039)((0, $f347e48613385d9c$export$2e2bcd8739ae039));
(0, $4bb895f7d67681bf$export$2e2bcd8739ae039)((0, $f347e48613385d9c$export$2e2bcd8739ae039));
(0, $0e088e5827e61707$export$2e2bcd8739ae039)((0, $f347e48613385d9c$export$2e2bcd8739ae039));
(0, $ewJru.default)((0, $f347e48613385d9c$export$2e2bcd8739ae039));
(0, $7b0256c106492184$export$2e2bcd8739ae039)((0, $f347e48613385d9c$export$2e2bcd8739ae039));
(0, $d104974fa1c57088$export$2e2bcd8739ae039)((0, $f347e48613385d9c$export$2e2bcd8739ae039));
(0, $b8dd5f968bd2f1b6$export$2e2bcd8739ae039)((0, $f347e48613385d9c$export$2e2bcd8739ae039));
(0, $c2c32f4d15da0450$export$2e2bcd8739ae039)((0, $f347e48613385d9c$export$2e2bcd8739ae039));
(0, $a7f0716e3e6baee3$export$2e2bcd8739ae039)((0, $f347e48613385d9c$export$2e2bcd8739ae039));
(0, $73724c2edf7a47bd$export$2e2bcd8739ae039)((0, $f347e48613385d9c$export$2e2bcd8739ae039));
(0, $f347e48613385d9c$export$2e2bcd8739ae039).start();

})();
//# sourceMappingURL=app.js.map
